import { CommonModule, NgFor, NgIf } from '@angular/common'
import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core'
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { NgbModal, NgbOffcanvas, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap'
import { filter, forkJoin, map, Observable, take, tap } from 'rxjs'
import { HasPermissionDirective } from '../../../directives/has-permission.directive'
import { CapitalizePipe } from '../../../pipes/capitalize.pipe'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import { Store } from '@ngrx/store'
import { ToastrService } from 'ngx-toastr'
import { UserService } from '../../../services/user.service'
import { selectUser } from '../../../store/auth/auth.selectors'
import { AttendancePolicyService } from '../../../services/attendance-policy.service'
import { AuthState, User, UserBusinesses } from '../../../store/auth/auth.state'
import { loadEmployees } from '../../../store/user/user.actions'
import { selectAllBusinesses } from '../../../store/business/business.selectors'
import { Business } from '../../../store/business/business.state'
import { loadBusinesses } from '../../../store/business/business.actions'
import { selectAllUsers } from '../../../store/user/user.selectors'
import { RouterModule } from '@angular/router'
import { eps } from '../../../services/url.service'
import { NgSelectModule } from '@ng-select/ng-select'
import { UtilsService } from '../../../services/utils.service'
import { SharedModule } from '../../../shared/shared.module'
import { firstClockInAfterShiftStartValidator } from './validators/firstclockinaftershiftstart'
import { TrimInputDirective } from '../../../directives/trim-input.directive'
import { noWhitespaceValidator } from '../../../validators/no-whitespace.validators'
import { HttpParams } from '@angular/common/http'
import { group } from 'node:console'

export enum ShiftType {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  FixedWeeklyOff = 'Fixed shift timing and fixed weekly offs',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  FixedShift = 'Fixed shift timing, but weekly offs vary by week of the month',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  SingleShift = 'Single shift, but timing vary depending on the day of the week',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  FlexibleShift = 'Flexible shift depending on clock timing'
}

export enum FirstClockInAfterTime {
  DOSENOTMETTER = "It doesn't matter. Employees can clock-in at any time during the day without being marked as Late",
  CERTAINTIME = 'Employees needs to clock in by a certain time to be not marked as Late',
  MARKEDLATE = 'Employees are marked as Late'
}

export enum DefineValidClock {
  FIRSTCLOCKINLASTCLOCKOUT = 'First Clock In Last Clock Out',
  EVERYVALIDCLOCKIN = 'Every Valid Clock In and Clock Out Pair'
}

interface AttendancePolicy {
  id: string
  title: string
  description: string
  shiftType: string
  shiftStartTime: Date
  shiftEndTime: Date
  date: string
  disabled: boolean
  business: {
    id: string
    businessName: string
  }
  businessId: string
  isDefault: boolean

  firstClockInAfterTime: string | null
  firstClockInTime: string | null
  lopDays: number
  everyLateDays: number
  isLossOfPay: boolean
  isMarkedLate: boolean
  lopCalculationPeriod: string
  isSingleClockIn: boolean
  isMinimumWorkHours: boolean
  isBreakHour: boolean
  isSelfie: boolean
  minimumWorkHours: number
  breakHour: number
  workDayExtensionMinutes: number
  weeklyOffs: string[]
  defineValidClock: string
  isMidnightShift: boolean
  isOvertimeEnabled: boolean
}

type WeekValue = '1st' | '2nd' | '3rd' | '4th' | '5th'

interface Day {
  selected: any
  label: string
  value: string
  active: boolean
  weeks: WeekValue[]
  order: any
}
declare var bootstrap: any // Add this if you haven't already
declare var $: any // Declare jQuery

@Component({
  selector: 'app-attendance-policy',
  imports: [
    NgFor,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CapitalizePipe,
    HasPermissionDirective,
    PaginationComponent,
    RouterModule,
    NgSelectModule,
    SharedModule
  ],
  templateUrl: './attendance-policy.component.html',
  styleUrl: './attendance-policy.component.scss'
})
export class AttendancePolicyComponent implements OnInit {
  private store = inject(Store)
  private attendancePolicyService = inject(AttendancePolicyService)
  private userService = inject(UserService)
  private modalService = inject(NgbModal)
  private fb = inject(FormBuilder)
  toastr = inject(ToastrService)
  form!: FormGroup
  assignAttendancePolicyform!: FormGroup
  public policyList: AttendancePolicy[] = []
  public totalCount = 0
  public currentPage = 1
  public pageLimit = 10

  shifts: any[] = []
  public search = ''
  public order = 'desc'
  public isArchived = false
  public businessId: string | undefined
  businessList: UserBusinesses[] | undefined = []
  DeleteId!: string
  blockUnblockId!: string
  blockUnblockStatus!: string
  blockTilte: string | undefined
  EditHoliday: AttendancePolicy | null = null
  // selectedBusiness = ''
  selectedBusiness: string | null = null
  modalPolicyList: AttendancePolicy[] = []
  shiftTypeEnum = ShiftType // Make the enum accessible in the template
  currentStep = 1
  steps = [1, 2, 3] // Steps for the form
  isBreakHoursStatus = false
  isSingleClockInStatus = false
  isMinimumWorkHoursStatus = false
  isSelfieStatus = false
  firstClockInTimeStatus = false
  isLossOfPayStatus = true
  defineValidClockStatus = false
  isMarkedLateStatus = false
  firstClockInTimeType = FirstClockInAfterTime
  selectedBusinessOwnerSort = ''
  pageLastRecord = 0
  defineValidClockEnum = DefineValidClock
  isLoading = false
  isEditMode = false;
  days: Day[] = [
    { label: 'M', value: 'Monday', active: false, weeks: [], selected: false, order: 1 },
    { label: 'T', value: 'Tuesday', active: false, weeks: [], selected: false, order: 2 },
    { label: 'W', value: 'Wednesday', active: false, weeks: [], selected: false, order: 3 },
    { label: 'Th', value: 'Thursday', active: false, weeks: [], selected: false, order: 4 },
    { label: 'F', value: 'Friday', active: false, weeks: [], selected: false, order: 5 },
    { label: 'S', value: 'Saturday', active: false, weeks: [], selected: false, order: 6 },
    { label: 'Su', value: 'Sunday', active: false, weeks: [], selected: false, order: 7 }
  ]
  public employeeList: User[] = []
  businessIdss!: string[]
  businesses$: Observable<Business[]> = this.store.select(selectAllBusinesses)
  // selectedBusinessId = ''
  selectedBusinessId: string | null = null

  employees$!: Observable<User[]>
  employees!: User[]
  user: AuthState['user'] | null = null
  weekOptions: { label: string; value: WeekValue }[] = [
    { label: '1st', value: '1st' },
    { label: '2nd', value: '2nd' },
    { label: '3rd', value: '3rd' },
    { label: '4th', value: '4th' },
    { label: '5th', value: '5th' }
  ]
  // Controls offcanvas visibility
  showShiftForm = false

  // Temporary form for creating a shift
  tempShiftForm!: FormGroup
  // Days selected for current shift
  selectedDays: Day[] = []
  offcanvasRef!: NgbOffcanvasRef
  minDate!: string
  availableDays: Day[] = []

  // shivam 23-04-2026
  lopOptions = [
    { label: 'Weekly', value: 'WEEK' },
    { label: 'Monthly', value: 'MONTH' }
  ]


  constructor(
    //  private assignAttendancePolicyService: AssignAttendancePolicyService
    private offcanvasService: NgbOffcanvas,
    private utilService: UtilsService,
    private cdr: ChangeDetectorRef,
    private toast: ToastrService
  ) { }

  ngOnInit(): void {
    this.store
      .select(selectUser)
      .pipe(take(1))
      .subscribe(user => {
        if (this.isAdmin) {
          // this.loadAllBusinesses()
          this.getAttendancePolicyList()
        }
        this.user = user
        const businessIds = user?.businessIds // your array of business IDs
        if (businessIds && businessIds.length) {
          this.businessIdss = businessIds
          // const paramString = `businessIds=${businessIds.join(',')}`
          // this.store.dispatch(loadBusinesses({ params: paramString }))
        }

        // This code is added by Shivam
        const tomorrow = new Date()
        tomorrow.setDate(tomorrow.getDate() + 1)

        this.minDate = tomorrow.toISOString().split('T')[0]
        //this.selectedBusiness = user?.business?.id

        this.businessList = user?.businesses
        //if (this.user?.role.name === 'Business Owner') {
        //  this.selectedBusinessOwner = this.user.businessOwnerId
        //}
        this.getAttendancePolicyList()
      })
    this.loadAllBusinesses()
    this.employees$ = this.store.select(selectAllUsers)
    // this.userService
    //   .getEmployees()
    //   .pipe(take(1))
    //   .subscribe(employeeList => {
    //     this.employeeList = employeeList.users
    //   })

    //this.initializeForm()

    this.form = this.fb.group(
      {
        businessId: ['', Validators.required],
        title: ['', [Validators.required]], // Example validators
        description: ['', [Validators.required, noWhitespaceValidator()]], // Example validators
        shiftType: ['', [Validators.required]], // Example validators
        shiftStartTime: ['', [Validators.required]], // Example validators
        shiftEndTime: ['', [Validators.required]], // Example validators
        isMidnightShift: [false],
        isOvertimeEnabled: [false],
        lopCalculationPeriod: ['MONTH'],
        weeklyOffs: [''], // Example validators
        isBreakHour: [this.isBreakHoursStatus, [Validators.required]], // Initialize accordingly
        breakHour: [0, [Validators.max(24)]], // Example validators
        // isSingleClockIn: [''], // Example validators
        defineValidClock: [this.defineValidClockEnum.FIRSTCLOCKINLASTCLOCKOUT, [Validators.required]], // Example validators
        isMinimumWorkHours: [this.isMinimumWorkHoursStatus], // Example validators
        minimumWorkHours: [0, [Validators.required, Validators.min(2)]],
        workDayExtensionMinutes: [0], // Example validators
        isSelfie: [false], // Example validators
        firstClockInAfterTime: [FirstClockInAfterTime.DOSENOTMETTER],
        // isMarkedLate: [''], // Example validators
        firstClockInTime: [null], // Example validators
        // isLossOfPay: [''], // Example validators
        lopDays: [0], // Example validators
        isSingleClockIn: [false],
        isMarkedLate: [false],
        bufferZone: [0],
        PolicyEffectiveDate: ['', [Validators.required]],
        isLossOfPay: [false],
        everyLateDays: [0], // Example validators
        disabled: [false],
        variableWeeklyOffs: this.fb.array([]), // for storing selected Saturdays (e.g., 2nd, 4th)
        shiftRecords: this.fb.array([])
      },
      {
        validators: firstClockInAfterShiftStartValidator
      }


    )


    // this code is add by shivam 16-04-2026
    // Whenever the value changes, it checks which option is selected
    this.form.get('firstClockInAfterTime')?.valueChanges.subscribe(value => {
      if (value === FirstClockInAfterTime.DOSENOTMETTER) {
        this.toggleFirstclockin('firstclockin')
      }
      else if (value === FirstClockInAfterTime.CERTAINTIME) {
        this.toggleFirstclockin('everyvalidclockin')
      }
      else if (value === FirstClockInAfterTime.MARKEDLATE) {
        this.toggleFirstclockin('markedlate')
      }
    })




    //  to set the high and min value for LOP days
    // this.form.get('lopCalculationPeriod')?.valueChanges.subscribe(period => {
    //   const control = this.form.get('everyLateDays')

    //   if (!control) return

    //   if (period === 'WEEK') {
    //     control.setValidators([Validators.min(1), Validators.max(7)])
    //   } else {
    //     control.setValidators([Validators.min(1), Validators.max(31)])
    //   }

    //   control.updateValueAndValidity()
    // })

    this.form.get('lopCalculationPeriod')?.valueChanges.subscribe(period => {
      this.updateEveryLateDaysValidators(period);
    });

    this.form.get('isLossOfPay')?.valueChanges.subscribe(value => {
      this.isLossOfPayStatus = value;
      this.updateEveryLateDaysValidators(this.form.get('lopCalculationPeriod')?.value);
    });

    this.form.get('shiftStartTime')?.valueChanges.subscribe(() => {
      this.checkMidnightShift();
    });

    this.form.get('shiftEndTime')?.valueChanges.subscribe(() => {
      this.checkMidnightShift();
    });

    this.form.get('isMidnightShift')?.valueChanges.subscribe(value => {
      if (value) {
        this.validateMidnightSelection();
      }
    });

    // this.assignAttendancePolicyform = this.fb.group({
    //   employeeIds: [[], [Validators.required]], // Example validators
    //   // Example validators
    //   attendancePolicyId: ['', [Validators.required]], // Example validators
    //   businessId: ['', Validators.required]

    // })

    // This Code is written by SHIVAM
    this.assignAttendancePolicyform = this.fb.group({
      employeeIds: [[], Validators.required],
      attendancePolicyId: ['', Validators.required],
      businessId: ['', Validators.required],
      assignmentDate: ['', Validators.required] // ✅ ADD THIS
    })

    // This code End HERE

    this.form.get('isBreakHour')?.valueChanges.subscribe(value => {
      // this.isBreakHoursStatus = value // Update your boolean status
      this.toggleBreakhours(value)
    })


    // this.form.get('additionalInfoForm.isSingleClockIn')?.valueChanges.subscribe(value => {
    //   this.isSingleClockInStatus = value === '1';
    // });

    // this.form.get('defineValidClock')?.valueChanges.subscribe(value => {
    //   this.defineValidClockStatus = value
    // })

    // this.form.get('firstClockInTime')?.valueChanges.subscribe(value => {
    //   this.firstClockInTimeStatus = !!value
    // })

    // this.toggleisSingleClockIn();
    // this.toggleisMinimumWorkHours();
    // this.toggleisSelfie();
    this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.DOSENOTMETTER)
    this.form.get('isLossOfPay')?.valueChanges.subscribe(value => {
      this.isLossOfPayStatus = value
    })

    this.businesses$.subscribe(businesses => {
      if (businesses.length === 1) {
        this.form.get('businessId')?.setValue(businesses[0].id)
        this.selectedBusinessId = businesses[0].id
        this.selectedBusiness = businesses[0].id
        // this.onBusinessChange(businesses[0].id)
        this.getAttendancePolicyList()
      }
    })

    this.tempShiftForm = this.fb.group({
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      isBreakHour: ['', [Validators.required]],

      breakHours: [0, [Validators.max(24)]],
      isFullDay: [true],
      hasMinHours: [false],
      minimumHours: [0],
      days: [[]] // this will hold selected days like ['Monday', 'Tuesday', ...]
    })

    this.form.get('shiftType')?.valueChanges.subscribe(value => {
      this.updateShiftTimeValidators(value)
    })

    // Optionally call it once to ensure it's set correctly initially
    this.updateShiftTimeValidators(this.form.get('shiftType')?.value)
  }

  //pagination
  onPageChange(newPage: number): void {
    if (newPage > 0) {
      this.currentPage = newPage
      this.getAttendancePolicyList()
      this.updatePageLastRecord()
    }
  }

  updateEveryLateDaysValidators(period: string) {
    const control = this.form.get('everyLateDays');
    if (!control) return;

    const isLossOfPayEnabled = this.form.get('isLossOfPay')?.value;

    if (!isLossOfPayEnabled) {

      control.clearValidators();
    } else {

      if (period === 'WEEK') {
        control.setValidators([Validators.min(0), Validators.max(7)]);
      } else {
        control.setValidators([Validators.min(0), Validators.max(31)]);
      }
    }

    control.updateValueAndValidity({ emitEvent: false });


  }



  // updateEveryLateDaysValidators(period: string) {

  //   const everyLateDaysControl =
  //     this.form.get('everyLateDays');

  //   const lopDaysControl =
  //     this.form.get('lopDays');

  //   if (!everyLateDaysControl || !lopDaysControl) return;

  //   const isLossOfPayEnabled =
  //     this.form.get('isLossOfPay')?.value;

  //   // Custom rule selected (No)
  //   if (isLossOfPayEnabled === false) {

  //     if (period === 'WEEK') {

  //       everyLateDaysControl.setValidators([
  //         Validators.required,
  //         Validators.min(1),
  //         Validators.max(7)
  //       ]);

  //     } else {

  //       everyLateDaysControl.setValidators([
  //         Validators.required,
  //         Validators.min(1),
  //         Validators.max(31)
  //       ]);
  //     }

  //   } else {

  //     // YES selected → clear values
  //     everyLateDaysControl.clearValidators();

  //     everyLateDaysControl.setValue(0);

  //     lopDaysControl.setValue(0);

  //     everyLateDaysControl.markAsUntouched();

  //     lopDaysControl.markAsUntouched();
  //   }

  //   // everyLateDaysControl.updateValueAndValidity({
  //   //   emitEvent: false
  //   // });

  //   // lopDaysControl.updateValueAndValidity({
  //   //   emitEvent: false
  //   // });
  // }

  reorderDays() {
    const inactiveDays = this.days
      .filter(d => !d.active)
      .sort((a, b) => a.order - b.order)

    const activeDays = this.days
      .filter(d => d.active)
      .sort((a, b) => a.order - b.order)

    this.days = [...inactiveDays, ...activeDays]
  }
  //modal open
  // openBusiness(content: unknown) {
  //   // this.modalService.open(content, { scrollable: false, centered: true, size: 'lg' })

  //   // this code is add by shivam 16-04-202
  //   const modalRef = this.modalService.open(content, { scrollable: false, centered: true, size: 'lg' })
  //   modalRef.result
  //     .then(
  //       () => {
  //         // Closed via button (OK)
  //         this.onClose()
  //       },
  //       () => {
  //         // ❗ Closed via backdrop click OR ESC 
  //         this.onClose()
  //       }
  //     )
  // }

  private modalRef: any;

  openBusiness(content: unknown) {
    // ✅ if modal already open, close it first and reset
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }

    this.modalRef = this.modalService.open(content, {
      scrollable: false,
      centered: true,
      size: 'lg'
    });

    // ✅ handles click outside (backdrop click) and ESC key
    // This is what gives you the "click outside resets to step 1" feature
    this.modalRef.result.then(
      () => {
        // closed via button — already handled by onClose()
        this.modalRef = null;
      },
      () => {
        // dismissed via outside click or ESC — reset everything
        this.resetAttendancePolicyForm();
        this.modalRef = null;
      }
    );
  }

  // this code is add by shivam 21-04-2026
  // ----------code start------------
  checkMidnightShift() {
    const start = this.form.get('shiftStartTime')?.value;
    const end = this.form.get('shiftEndTime')?.value;

    if (!start || !end) return;

    // Convert HH:mm to minutes
    const [startH, startM] = start.split(':').map(Number);
    const [endH, endM] = end.split(':').map(Number);

    const startMinutes = startH * 60 + startM;
    const endMinutes = endH * 60 + endM;

    const isMidnight = endMinutes < startMinutes;

    this.form.patchValue({
      isMidnightShift: isMidnight
    }, { emitEvent: false });
  }


  validateMidnightSelection() {
    const start = this.form.get('shiftStartTime')?.value;
    const end = this.form.get('shiftEndTime')?.value;

    if (!start || !end) return;

    const [startH, startM] = start.split(':').map(Number);
    const [endH, endM] = end.split(':').map(Number);

    const startMinutes = startH * 60 + startM;
    const endMinutes = endH * 60 + endM;

    const isMidnight = endMinutes < startMinutes;

    if (!isMidnight) {
      // ❌ Invalid → revert checkbox
      this.form.patchValue({ isMidnightShift: false }, { emitEvent: false });


      // alert('This shift does not cross midnight. Please select valid timings.');
      this.toast.error('Shift does not cross midnight. Please select valid timings.')
    }
  }

  //--------code finish ------------


  //modal close
  // onClose() {
  //   // this.getAttendancePolicyList();
  //   this.isEditMode = false;
  //   this.form.reset()
  //   this.assignAttendancePolicyform.reset()
  //   this.modalService.dismissAll()
  //   this.currentStep = 1
  //   this.isBreakHoursStatus =
  //     this.isLossOfPayStatus =
  //     this.isMarkedLateStatus =
  //     this.isMinimumWorkHoursStatus =
  //     this.isSelfieStatus =
  //     this.isSingleClockInStatus =
  //     false
  //   this.cdr.detectChanges() // force UI update
  //   // this.selectedBusiness = null
  //   this.getAttendancePolicyList()
  // }

  onClose() {
    this.isEditMode = false;
    this.EditHoliday = null;
    this.modalService.dismissAll();
    this.currentStep = 1;

    // ✅ DO NOT reset selectedBusiness here — it breaks getAttendancePolicyList
    // this.selectedBusiness = null;  ← REMOVE THIS LINE

    this.isBreakHoursStatus =
      this.isLossOfPayStatus =
      this.isMarkedLateStatus =
      this.isMinimumWorkHoursStatus =
      this.isSelfieStatus =
      this.isSingleClockInStatus =
      false;

    this.cdr.detectChanges();
    this.getAttendancePolicyList();
  }
  // ✅ onClose — just delegate to resetAttendancePolicyForm
  // onClose() {
  //   if (this.modalRef) {
  //     this.modalRef.close();

  //     this.modalRef.result.finally(() => {
  //       this.resetAttendancePolicyForm();
  //       this.EditHoliday = null;
  //       this.modalRef = null;
  //     });

  //     return;
  //   }

  //   this.resetAttendancePolicyForm();
  //   this.EditHoliday = null;
  // }
  // currently working on this method
  //   onClose() {
  //   this.modalService.dismissAll()
  //   this.currentStep = 1
  //   this.selectedBusiness = null
  //   this.getAttendancePolicyList()
  // }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }


  // getAttendancePolicyList() {
  //   this.isArchived = false
  //   //let skip = this.currentPage * this.pageLimit - this.pageLimit
  //   //let search = this.search
  //   //  ? {
  //   //      $or: { title: { $like: `%${this.search}%` } },
  //   //      $and: { businessId: { $like: `%${this.selectedBusiness}%` } }
  //   //    }
  //   //  : { businessId: { $like: `%${this.selectedBusiness}%` } }
  //   // if (this.selectedBusiness) {
  //   this.attendancePolicyService
  //     .list(this.selectedBusiness!, this.search!, this.currentPage, this.pageLimit)
  //     .subscribe({
  //       next: response => {
  //         // console.log('leave policy', response.rows)
  //         this.policyList = response.attendancePolicies
  //         this.totalCount = response.totalCount
  //         this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)

  //         this.policyList.forEach(policy => {
  //           policy.shiftStartTime = new Date(`1970-01-01T${policy.shiftStartTime}`)
  //           policy.shiftEndTime = new Date(`1970-01-01T${policy.shiftEndTime}`)
  //         })



  //       },
  //       error: (error: { message: string }) => {
  //         this.toastr.error('Error: ' + error.message)
  //       }
  //     })
  //   // }
  // }

  getAttendancePolicyList() {
    this.attendancePolicyService
      .list(this.selectedBusiness!, this.search!, this.currentPage, this.pageLimit)
      .subscribe({
        next: response => {
          // ✅ Always assign a fresh array — no mutation
          this.policyList = response.attendancePolicies.map((policy: any) => ({
            ...policy,
            shiftStartTime: new Date(`1970-01-01T${policy.shiftStartTime}`),
            shiftEndTime: new Date(`1970-01-01T${policy.shiftEndTime}`)
          }));

          this.totalCount = response.totalCount;
          this.pageLastRecord = Math.min(
            this.currentPage * this.pageLimit,
            this.totalCount
          );
        },
        error: (error: { message: string }) => {
          this.toastr.error('Error: ' + error.message);
        }
      });
  }

  openBlockUnblock(content: unknown, id: string, title: string, status: string) {
    this.blockUnblockId = id
    this.blockTilte = title
    if (status === 'Active') {
      this.blockUnblockStatus = 'Inactive'
    } else if (status === 'Inactive') {
      this.blockUnblockStatus = 'Active'
    }

    this.modalService.open(content, { scrollable: false, centered: true, size: 'sm' })
  }

  confirmBlockUnblock() {
    if (this.blockUnblockId) {
      // Prepare the request body
      const requestBody = {
        status: this.blockUnblockStatus,
        id: this.blockUnblockId,
        title: this.blockTilte
      }

      this.attendancePolicyService.update(this.blockUnblockId, requestBody).subscribe(res => {
        if (res.id) {
          this.getAttendancePolicyList()
          this.resetAttendancePolicyForm()
          this.toastr.success(
            'SUCCESS',
            'Attendance Policy ' + this.blockUnblockStatus + ' successfully!'
          )
        }
      })
      // this.getAttendancePolicyList()
      this.onClose()
    }
  }

  openDelete(content: unknown, id: string) {
    this.DeleteId = id
    this.modalService.open(content, { scrollable: false, centered: true, size: 'sm' })
  }

  confirmDelete() {
    if (this.DeleteId) {
      this.attendancePolicyService.delete(this.DeleteId).subscribe(() => {
        this.getAttendancePolicyList()
        this.resetAttendancePolicyForm()
        this.toastr.success('SUCCESS', 'Attendance Policy deleted  successfully!')
      })
      // this.getAttendancePolicyList()
      this.onClose()
    }
  }



  // Workinh openEditpolicy
  // openEditPolicy(content: unknown, holiday: any) {

  //   console.log('--- EDIT POLICY DATA ---');
  //   console.log('isSingleClockIn from server:', holiday.isSingleClockIn);
  //   console.log('isMinimumWorkHours from server:', holiday.isMinimumWorkHours);
  //   console.log('isSingleClockInStatus after set:', this.isSingleClockInStatus);
  //   console.log('isMinimumWorkHoursStatus after set:', this.isMinimumWorkHoursStatus);
  //   console.log('isSingleClockInDisabled:', this.isSingleClockInDisabled);
  //   console.log('isMinimumWorkHoursDisabled:', this.isMinimumWorkHoursDisabled);
  //   this.EditHoliday = holiday
  //   const shiftStartTime = new Date(holiday.shiftStartTime)
  //   const lopValue = holiday.lopCalculationPeriod?.toLowerCase()

  //   this.form.get('lopCalculationPeriod')?.setValue(
  //     lopValue === 'weekly' || lopValue === 'week' ? 'WEEK' : 'MONTH'
  //   )
  //   // Add this after all your setValue calls in openEditPolicy
  //   this.updateEveryLateDaysValidators(
  //     this.form.get('lopCalculationPeriod')?.value
  //   );

  //   if (!isNaN(shiftStartTime.getTime())) {
  //     // Extract hours and minutes
  //     const hours = String(shiftStartTime.getHours()).padStart(2, '0') // Pads single digits
  //     const minutes = String(shiftStartTime.getMinutes()).padStart(2, '0')

  //     // Format to HH:mm
  //     const formattedTime = `${hours}:${minutes}`

  //     // Set the formatted time into the form control
  //     this.form.get('shiftStartTime')?.setValue(formattedTime)
  //   }

  //   const shiftEndTime = new Date(holiday.shiftEndTime)
  //   if (!isNaN(shiftEndTime.getTime())) {
  //     const endHours = String(shiftEndTime.getHours()).padStart(2, '0')
  //     const endMinutes = String(shiftEndTime.getMinutes()).padStart(2, '0')
  //     const formattedEndTime = `${endHours}:${endMinutes}`
  //     this.form.get('shiftEndTime')?.setValue(formattedEndTime)
  //   }
  //   // console.log('is break hour', holiday.isBreakHour)
  //   this.isBreakHoursStatus = holiday.isBreakHour
  //   this.isLossOfPayStatus = holiday.isLossOfPay
  //   this.isMarkedLateStatus = holiday.isMarkedLate
  //   this.isMinimumWorkHoursStatus = holiday.isMinimumWorkHours

  //   this.isSelfieStatus = holiday.isSelfie
  //   if (this.isSelfieStatus === true) {
  //     this.toggleisSelfie()
  //   }
  //   this.isSingleClockInStatus = holiday.isSingleClockIn
  //   if (this.isSingleClockInStatus === true) {
  //     this.toggleisSingleClockIn()
  //   }

  //   // this.defineValidClockStatus = holiday.defineValidClock
  //   if (holiday.defineValidClock === 'First Clock in Last Clock Out') {
  //     this.defineValidClockStatus = true
  //   } else {
  //     this.defineValidClockStatus = false
  //   }
  //   this.form.get('defineValidClock')?.setValue(holiday.defineValidClock)
  //   // const shiftStartTime = JSON.stringify(holiday.shiftStartTime); // e.g., '05:17'
  //   // const shiftEndTime = JSON.stringify(holiday.shiftEndTime); // e.g., '06:00'
  //   this.form.get('title')?.setValue(holiday.title)
  //   this.form.get('shiftType')?.setValue(holiday.shiftType)
  //   // this.form.get('basicInfoForm.shiftStartTime')?.setValue(shiftStartTime)
  //   // this.form.get('basicInfoForm.shiftEndTime')?.setValue(shiftEndTime)
  //   this.form.get('description')?.setValue(holiday.description)
  //   this.form.get('businessId')?.setValue(holiday.businessId)
  //   this.form.get('weeklyOffs')?.setValue(holiday.weeklyOffs)
  //   this.form.get('shiftInfoForm.isBreakHours')?.setValue(holiday.breakHour)
  //   this.form.get('breakHour')?.setValue(holiday.breakHour)
  //   this.form.get('isBreakHour')?.setValue(holiday.isBreakHour)

  //   // this.form.get('additionalInfoForm.isSingleClockIn')?.setValue(holiday.isSingleClockIn)
  //   // this.form.get('additionalInfoForm.defineValidClock')?.setValue(holiday.defineValidClock)
  //   this.form.get('isMinimumWorkHours')?.setValue(holiday.isMinimumWorkHours)
  //   this.form.get('minimumWorkHours')?.setValue(holiday.minimumWorkHours)
  //   this.form.get('workDayExtensionMinutes')?.setValue(holiday.workDayExtensionMinutes)
  //   this.form.get('isLossOfPay')?.setValue(holiday.isLossOfPay)
  //   this.form.get('lopDays')?.setValue(holiday.lopDays)
  //   this.form.get('everyLateDays')?.setValue(holiday.everyLateDays)

  //   // this.form.get('additionalInfoForm.isSelfie')?.setValue(holiday.isSelfie)
  //   // this.form.get('additionalInfoForm.firstClockInAfterTime')?.setValue(holiday.firstClockInAfterTime)
  //   this.form.get('isLossOfPay')?.setValue(holiday.isLossOfPay)
  //   if (holiday.firstClockInAfterTime === this.firstClockInTimeType.MARKEDLATE) {
  //     this.toggleFirstclockin('markedlate')
  //   }
  //   this.form.get('lopDays')?.setValue(holiday.lopDays)
  //   this.form.get('everyLateDays')?.setValue(holiday.everyLateDays)
  //   if (
  //     holiday.firstClockInAfterTime ===
  //     "It doesn't matter. Employees can clock-in at any time during the day without being marked as Late"
  //   ) {
  //     this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.DOSENOTMETTER)
  //   } else if (
  //     holiday.firstClockInAfterTime ===
  //     'Employees needs to clock in by a certain time to be not marked as Late'
  //   ) {
  //     this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.CERTAINTIME)

  //     // this code is add by shivam
  //     this.toggleFirstclockin('everyvalidclockin')

  //     // ✅ SET VALUE
  //     this.form.get('firstClockInTime')?.setValue(holiday.firstClockInTime)
  //   } else if (holiday.firstClockInAfterTime === 'Employees are marked as Late') {
  //     this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.MARKEDLATE)
  //   }

  //   // console.log('is break hours status', this.isBreakHoursStatus)
  //   // console.log('isArray:', Array.isArray(holiday.weeklyOffs))

  //   // const daysArray = holiday.weeklyOffs.split(',').map((day: string) => day.trim())
  //   const daysArray = holiday.weeklyOffs
  //   daysArray.forEach((dayLabel: string) => {
  //     // const day = this.days.find(d => d.label === dayLabel)
  //     const day = this.days.find(d => d.value === dayLabel)

  //     if (day) {
  //       day.active = true // Set active to true for the corresponding day
  //     }
  //   })

  //   // this.modalService.open(content, { scrollable: false, centered: true, size: 'lg' })

  //   // this code is add by shivam
  //   const modalRef = this.modalService.open(content, { scrollable: false, centered: true, size: 'lg' })

  //   modalRef.result
  //     .then(
  //       () => {
  //         // Closed via button (OK)
  //         this.onClose()
  //       },
  //       () => {
  //         // ❗ Closed via backdrop click OR ESC 
  //         this.onClose()
  //       }
  //     )

  // }


  // openEditPolicy(content: unknown, holiday: any) {
  //   this.EditHoliday = holiday;
  //     this.isEditMode = true;
  //   //  Reset all flags first to avoid stale state from previous edit
  //   this.isSingleClockInStatus = false;
  //   this.isMinimumWorkHoursStatus = false;
  //   this.isSingleClockInDisabled = false;
  //   this.isMinimumWorkHoursDisabled = false;
  //   this.isSelfieStatus = false;
  //   this.isBreakHoursStatus = false;
  //   this.isLossOfPayStatus = false;
  //   this.isMarkedLateStatus = false;


  //   this.days.forEach(day => {
  //     day.active = false;
  //     day.weeks = [];
  //   });


  //   const shiftStartTime = new Date(holiday.shiftStartTime);
  //   if (!isNaN(shiftStartTime.getTime())) {
  //     const hours = String(shiftStartTime.getHours()).padStart(2, '0');
  //     const minutes = String(shiftStartTime.getMinutes()).padStart(2, '0');
  //     this.form.get('shiftStartTime')?.setValue(`${hours}:${minutes}`);
  //   }


  //   const shiftEndTime = new Date(holiday.shiftEndTime);
  //   if (!isNaN(shiftEndTime.getTime())) {
  //     const endHours = String(shiftEndTime.getHours()).padStart(2, '0');
  //     const endMinutes = String(shiftEndTime.getMinutes()).padStart(2, '0');
  //     this.form.get('shiftEndTime')?.setValue(`${endHours}:${endMinutes}`);
  //   }


  //   const lopValue = holiday.lopCalculationPeriod?.toLowerCase();
  //   this.form.get('lopCalculationPeriod')?.setValue(
  //     lopValue === 'weekly' || lopValue === 'week' ? 'WEEK' : 'MONTH'
  //   );


  //   this.form.get('title')?.setValue(holiday.title);
  //   this.form.get('shiftType')?.setValue(holiday.shiftType);
  //   this.form.get('description')?.setValue(holiday.description);
  //   this.form.get('businessId')?.setValue(holiday.businessId);
  //   this.form.get('weeklyOffs')?.setValue(holiday.weeklyOffs);
  //   this.form.get('breakHour')?.setValue(holiday.breakHour);
  //   this.form.get('minimumWorkHours')?.setValue(holiday.minimumWorkHours);
  //   this.form.get('workDayExtensionMinutes')?.setValue(holiday.workDayExtensionMinutes);
  //   this.form.get('lopDays')?.setValue(holiday.lopDays);
  //   this.form.get('everyLateDays')?.setValue(holiday.everyLateDays);
  //   this.form.get('defineValidClock')?.setValue(holiday.defineValidClock);
  //   this.form.get('isMidnightShift')?.setValue(holiday.isMidnightShift ?? false);
  //   this.form.get('isOvertimeEnabled')?.setValue(holiday.isOvertimeEnabled ?? false);
  //   this.form.get('disabled')?.setValue(holiday.disabled ?? false);


  //   this.isSingleClockInStatus = holiday.isSingleClockIn ?? false;
  //   this.isMinimumWorkHoursStatus = holiday.isMinimumWorkHours ?? false;
  //   this.isBreakHoursStatus = holiday.isBreakHour ?? false;
  //   this.isSelfieStatus = holiday.isSelfie ?? false;
  //   this.isLossOfPayStatus = holiday.isLossOfPay ?? false;
  //   this.isMarkedLateStatus = holiday.isMarkedLate ?? false;


  //   this.form.get('isSingleClockIn')?.setValue(this.isSingleClockInStatus);
  //   this.form.get('isMinimumWorkHours')?.setValue(this.isMinimumWorkHoursStatus);
  //   this.form.get('isBreakHour')?.setValue(this.isBreakHoursStatus);
  //   this.form.get('isSelfie')?.setValue(this.isSelfieStatus);
  //   this.form.get('isLossOfPay')?.setValue(this.isLossOfPayStatus);
  //   this.form.get('isMarkedLate')?.setValue(this.isMarkedLateStatus);


  //   this.isSingleClockInDisabled = this.isMinimumWorkHoursStatus;
  //   this.isMinimumWorkHoursDisabled = this.isSingleClockInStatus;


  //   this.defineValidClockStatus = holiday.defineValidClock === 'First Clock in Last Clock Out';


  //   const minimumWorkHoursControl = this.form.get('minimumWorkHours');
  //   if (this.isMinimumWorkHoursStatus) {
  //     minimumWorkHoursControl?.setValidators([Validators.required]);
  //   } else {
  //     minimumWorkHoursControl?.clearValidators();
  //   }
  //   minimumWorkHoursControl?.updateValueAndValidity();


  //   this.updateEveryLateDaysValidators(this.form.get('lopCalculationPeriod')?.value);


  //   if (
  //     holiday.firstClockInAfterTime ===
  //     "It doesn't matter. Employees can clock-in at any time during the day without being marked as Late"
  //   ) {
  //     this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.DOSENOTMETTER);
  //     this.toggleFirstclockin('firstclockin');
  //   } else if (
  //     holiday.firstClockInAfterTime ===
  //     'Employees needs to clock in by a certain time to be not marked as Late'
  //   ) {
  //     this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.CERTAINTIME);
  //     this.toggleFirstclockin('everyvalidclockin');
  //     this.form.get('firstClockInTime')?.setValue(holiday.firstClockInTime);
  //   } else if (holiday.firstClockInAfterTime === 'Employees are marked as Late') {
  //     this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.MARKEDLATE);
  //     this.toggleFirstclockin('markedlate');
  //   }


  //   const daysArray = holiday.weeklyOffs;
  //   daysArray.forEach((dayLabel: string) => {
  //     const day = this.days.find(d => d.value === dayLabel);
  //     if (day) {
  //       day.active = true;
  //     }
  //   });

  //   const modalRef = this.modalService.open(content, {
  //     scrollable: false,
  //     centered: true,
  //     size: 'lg'
  //   });

  //   modalRef.result.then(
  //     () => { this.onClose(); },
  //     () => { this.onClose(); }
  //   );
  // }




  // openEditPolicy(content: unknown, holiday: any) {
  //   this.EditHoliday = holiday


  //   // console.log('LOP VALUE FROM API:', holiday.lopCalculationPeriod)


  //   const lopValue = holiday.lopCalculationPeriod?.toLowerCase()

  //   this.form.get('lopCalculationPeriod')?.setValue(
  //     lopValue === 'weekly' || lopValue === 'week' ? 'WEEK' : 'MONTH'
  //   )

  //   const shiftStartTime = new Date(holiday.shiftStartTime)
  //   if (!isNaN(shiftStartTime.getTime())) {
  //     const hours = String(shiftStartTime.getHours()).padStart(2, '0')
  //     const minutes = String(shiftStartTime.getMinutes()).padStart(2, '0')
  //     const formattedTime = `${hours}:${minutes}`
  //     this.form.get('shiftStartTime')?.setValue(formattedTime)
  //   }

  //   const shiftEndTime = new Date(holiday.shiftEndTime)
  //   if (!isNaN(shiftEndTime.getTime())) {
  //     const endHours = String(shiftEndTime.getHours()).padStart(2, '0')
  //     const endMinutes = String(shiftEndTime.getMinutes()).padStart(2, '0')
  //     const formattedEndTime = `${endHours}:${endMinutes}`
  //     this.form.get('shiftEndTime')?.setValue(formattedEndTime)
  //   }

  //   this.isBreakHoursStatus = holiday.isBreakHour
  //   this.isLossOfPayStatus = holiday.isLossOfPay
  //   this.isMarkedLateStatus = holiday.isMarkedLate
  //   this.isMinimumWorkHoursStatus = holiday.isMinimumWorkHours

  //   this.isSelfieStatus = holiday.isSelfie
  //   if (this.isSelfieStatus) {
  //     this.toggleisSelfie()
  //   }

  //   this.isSingleClockInStatus = holiday.isSingleClockIn
  //   if (this.isSingleClockInStatus) {
  //     this.toggleisSingleClockIn()
  //   }

  //   this.defineValidClockStatus =
  //     holiday.defineValidClock === 'First Clock in Last Clock Out'

  //   this.form.get('defineValidClock')?.setValue(holiday.defineValidClock)
  //   this.form.get('title')?.setValue(holiday.title)
  //   this.form.get('shiftType')?.setValue(holiday.shiftType)
  //   this.form.get('description')?.setValue(holiday.description)
  //   this.form.get('businessId')?.setValue(holiday.businessId)
  //   this.form.get('weeklyOffs')?.setValue(holiday.weeklyOffs)
  //   this.form.get('breakHour')?.setValue(holiday.breakHour)
  //   this.form.get('isBreakHour')?.setValue(holiday.isBreakHour)

  //   this.form.get('isMinimumWorkHours')?.setValue(holiday.isMinimumWorkHours)
  //   this.form.get('minimumWorkHours')?.setValue(holiday.minimumWorkHours)
  //   this.form.get('workDayExtensionMinutes')?.setValue(holiday.workDayExtensionMinutes)

  //   this.form.get('isLossOfPay')?.setValue(holiday.isLossOfPay)
  //   this.form.get('lopDays')?.setValue(holiday.lopDays)
  //   this.form.get('everyLateDays')?.setValue(holiday.everyLateDays)

  //   if (holiday.firstClockInAfterTime === this.firstClockInTimeType.MARKEDLATE) {
  //     this.toggleFirstclockin('markedlate')
  //   }

  //   if (
  //     holiday.firstClockInAfterTime ===
  //     "It doesn't matter. Employees can clock-in at any time during the day without being marked as Late"
  //   ) {
  //     this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.DOSENOTMETTER)
  //   } else if (
  //     holiday.firstClockInAfterTime ===
  //     'Employees needs to clock in by a certain time to be not marked as Late'
  //   ) {
  //     this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.CERTAINTIME)
  //     this.toggleFirstclockin('everyvalidclockin')
  //     this.form.get('firstClockInTime')?.setValue(holiday.firstClockInTime)
  //   } else if (
  //     holiday.firstClockInAfterTime === 'Employees are marked as Late'
  //   ) {
  //     this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.MARKEDLATE)
  //   }

  //   // Weekly offs
  //   const daysArray = holiday.weeklyOffs
  //   daysArray.forEach((dayLabel: string) => {
  //     const day = this.days.find(d => d.value === dayLabel)
  //     if (day) {
  //       day.active = true
  //     }
  //   })

  //   const modalRef = this.modalService.open(content, {
  //     scrollable: false,
  //     centered: true,
  //     size: 'lg'
  //   })

  //   modalRef.result.then(
  //     () => this.onClose(),
  //     () => this.onClose()
  //   )
  // }

  //  openEditPolicy(content: unknown, holiday: any) {

  //   this.EditHoliday = holiday;
  //   this.isEditMode = true;

  //   // -----------------------------
  //   // RESET EVERYTHING
  //   // -----------------------------
  //   this.form.reset();

  //   this.isSingleClockInStatus = false;
  //   this.isMinimumWorkHoursStatus = false;
  //   this.isSingleClockInDisabled = false;
  //   this.isMinimumWorkHoursDisabled = false;
  //   this.isSelfieStatus = false;
  //   this.isBreakHoursStatus = false;
  //   this.isLossOfPayStatus = false;
  //   this.isMarkedLateStatus = false;
  //   this.firstClockInTimeStatus = false;
  //   this.defineValidClockStatus = false;

  //   this.days.forEach(day => {
  //     day.active = false;
  //     day.weeks = [];
  //   });

  //   // -----------------------------
  //   // TIME FORMATTER
  //   // -----------------------------
  //   const formatTime = (time: any): string | null => {
  //     if (!time) return null;

  //     const date = new Date(time);
  //     if (isNaN(date.getTime())) return null;

  //     const h = String(date.getHours()).padStart(2, '0');
  //     const m = String(date.getMinutes()).padStart(2, '0');

  //     return `${h}:${m}`;
  //   };

  //   // -----------------------------
  //   // MAP FIRST CLOCK IN VALUE
  //   // -----------------------------
  //   let firstClockInMapped = FirstClockInAfterTime.DOSENOTMETTER;

  //   if (
  //     holiday.firstClockInAfterTime ===
  //     'Employees needs to clock in by a certain time to be not marked as Late'
  //   ) {
  //     firstClockInMapped = FirstClockInAfterTime.CERTAINTIME;
  //   }

  //   else if (
  //     holiday.firstClockInAfterTime ===
  //     'Employees are marked as Late'
  //   ) {
  //     firstClockInMapped = FirstClockInAfterTime.MARKEDLATE;
  //   }



  //     // if (
  //     //   holiday.firstClockInAfterTime ===
  //     //   "It doesn't matter. Employees can clock-in at any time during the day without being marked as Late"
  //     // ) {
  //     //   this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.DOSENOTMETTER)
  //     // } else if (
  //     //   holiday.firstClockInAfterTime ===
  //     //   'Employees needs to clock in by a certain time to be not marked as Late'
  //     // ) {
  //     //   this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.CERTAINTIME)
  //     //   this.toggleFirstclockin('everyvalidclockin')
  //     //   this.form.get('firstClockInTime')?.setValue(holiday.firstClockInTime)
  //     // } else if (
  //     //   holiday.firstClockInAfterTime === 'Employees are marked as Late'
  //     // ) {
  //     //   this.form.get('firstClockInAfterTime')?.setValue(FirstClockInAfterTime.MARKEDLATE)
  //     // }

  //   // -----------------------------
  //   // PATCH FORM (ONLY DATA)
  //   // -----------------------------
  //   this.form.patchValue({
  //     title: holiday.title ?? '',
  //     shiftType: holiday.shiftType ?? '',

  //     description: holiday.description ?? '',
  //     businessId: holiday.businessId ?? '',

  //     weeklyOffs: holiday.weeklyOffs ?? [],

  //     shiftStartTime: formatTime(holiday.shiftStartTime),
  //     shiftEndTime: formatTime(holiday.shiftEndTime),

  //     breakHour: holiday.breakHour ?? 0,
  //     minimumWorkHours: holiday.minimumWorkHours ?? 0,
  //     workDayExtensionMinutes: holiday.workDayExtensionMinutes ?? 0,

  //     lopDays: holiday.lopDays ?? 0,
  //     everyLateDays: holiday.everyLateDays ?? 0,

  //     lopCalculationPeriod:
  //       (holiday.lopCalculationPeriod?.toLowerCase() === 'weekly' ||
  //        holiday.lopCalculationPeriod?.toLowerCase() === 'week')
  //         ? 'WEEK'
  //         : 'MONTH',

  //     isMidnightShift: holiday.isMidnightShift ?? false,
  //     isOvertimeEnabled: holiday.isOvertimeEnabled ?? false,
  //     disabled: holiday.disabled ?? false,

  //     isSingleClockIn: holiday.isSingleClockIn ?? false,
  //     isMinimumWorkHours: holiday.isMinimumWorkHours ?? false,
  //     isBreakHour: holiday.isBreakHour ?? false,
  //     isSelfie: holiday.isSelfie ?? false,
  //     isLossOfPay: holiday.isLossOfPay ?? false,
  //     isMarkedLate: holiday.isMarkedLate ?? false,

  //     firstClockInAfterTime: firstClockInMapped,
  //     firstClockInTime: holiday.firstClockInTime ?? null,

  //     defineValidClock: holiday.defineValidClock ?? ''
  //   });

  //   // -----------------------------
  //   // FLAGS ONLY (NO LOGIC HERE)
  //   // -----------------------------
  //   this.isSingleClockInStatus = holiday.isSingleClockIn ?? false;
  //   this.isMinimumWorkHoursStatus = holiday.isMinimumWorkHours ?? false;
  //   this.isBreakHoursStatus = holiday.isBreakHour ?? false;
  //   this.isSelfieStatus = holiday.isSelfie ?? false;
  //   this.isLossOfPayStatus = holiday.isLossOfPay ?? false;
  //   this.isMarkedLateStatus = holiday.isMarkedLate ?? false;

  //   // -----------------------------
  //   // DISABLE STATES
  //   // -----------------------------
  //   this.isSingleClockInDisabled = this.isMinimumWorkHoursStatus;
  //   this.isMinimumWorkHoursDisabled = this.isSingleClockInStatus;

  //   // -----------------------------
  //   // VALIDATORS
  //   // -----------------------------
  //   const minCtrl = this.form.get('minimumWorkHours');

  //   if (this.isMinimumWorkHoursStatus) {
  //     minCtrl?.setValidators([Validators.required]);
  //   } else {
  //     minCtrl?.clearValidators();
  //   }

  //   minCtrl?.updateValueAndValidity();

  //   // -----------------------------
  //   // WEEKLY OFFS
  //   // -----------------------------
  //   (holiday.weeklyOffs ?? []).forEach((dayLabel: string) => {
  //     const day = this.days.find(d => d.value === dayLabel);
  //     if (day) day.active = true;
  //   });

  //   // -----------------------------
  //   // OPEN MODAL
  //   // -----------------------------
  //   this.modalService.open(content, {
  //     scrollable: false,
  //     centered: true,
  //     size: 'lg'
  //   });
  // }

  openEditPolicy(content: unknown, holiday: any) {

    this.currentStep = 1;

    this.EditHoliday = { ...holiday };
    this.isEditMode = true;

    // RESET FLAGS FIRST
    this.isSingleClockInStatus = false;
    this.isMinimumWorkHoursStatus = false;
    this.isSingleClockInDisabled = false;
    this.isMinimumWorkHoursDisabled = false;
    this.isSelfieStatus = false;
    this.isBreakHoursStatus = false;
    this.isLossOfPayStatus = false;
    this.isMarkedLateStatus = false;
    this.firstClockInTimeStatus = false;
    this.defineValidClockStatus = false;

    // RESET DAYS
    this.days.forEach(day => {
      day.active = false;
      day.weeks = [];
    });

    // FORMAT TIME — handles both Date objects AND "HH:mm" strings from DB
    const formatTime = (time: any): string | null => {
      if (!time) return null;

      if (typeof time === 'string' && /^\d{2}:\d{2}$/.test(time)) {
        return time;
      }

      const date = new Date(time);
      if (isNaN(date.getTime())) return null;

      const h = String(date.getHours()).padStart(2, '0');
      const m = String(date.getMinutes()).padStart(2, '0');
      return `${h}:${m}`;
    };

    // MAP FIRST CLOCK IN
    const clockInVal = holiday.firstClockInAfterTime?.trim();

    let firstClockInMapped: FirstClockInAfterTime;

    if (clockInVal === FirstClockInAfterTime.CERTAINTIME) {
      firstClockInMapped = FirstClockInAfterTime.CERTAINTIME;
    } else if (clockInVal === FirstClockInAfterTime.MARKEDLATE) {
      firstClockInMapped = FirstClockInAfterTime.MARKEDLATE;
    } else {
      firstClockInMapped = FirstClockInAfterTime.DOSENOTMETTER;
    }

    // console.log(holiday);
    // BUILD PATCH OBJECT
    const patchData = {
      title: holiday.title ?? '',
      shiftType: holiday.shiftType ?? '',
      description: holiday.description ?? '',
      businessId: holiday.businessId ?? '',
      PolicyEffectiveDate: holiday.PolicyEffectiveDate ?? '',

      weeklyOffs: holiday.weeklyOffs ?? [],

      shiftStartTime: formatTime(holiday.shiftStartTime),
      shiftEndTime: formatTime(holiday.shiftEndTime),

      breakHour: holiday.breakHour ?? 0,
      minimumWorkHours: holiday.minimumWorkHours ?? 0,
      workDayExtensionMinutes: holiday.workDayExtensionMinutes ?? 0,

      lopDays: holiday.lopDays ?? 0,
      everyLateDays: holiday.everyLateDays ?? 0,

      lopCalculationPeriod:
        (holiday.lopCalculationPeriod?.toLowerCase() === 'weekly' ||
          holiday.lopCalculationPeriod?.toLowerCase() === 'week')
          ? 'WEEK'
          : 'MONTH',

      isMidnightShift: holiday.isMidnightShift ?? false,
      isOvertimeEnabled: holiday.isOvertimeEnabled ?? false,
      disabled: holiday.disabled ?? false,

      isSingleClockIn: holiday.isSingleClockIn ?? false,
      isMinimumWorkHours: holiday.isMinimumWorkHours ?? false,
      isBreakHour: holiday.isBreakHour ?? false,
      isSelfie: holiday.isSelfie ?? false,
      isLossOfPay: holiday.isLossOfPay ?? false,
      isMarkedLate: holiday.isMarkedLate ?? false,

      firstClockInAfterTime: firstClockInMapped,

      // ✅ firstClockInTime only for CERTAINTIME, null otherwise
      firstClockInTime: firstClockInMapped === FirstClockInAfterTime.CERTAINTIME
        ? holiday.firstClockInTime ?? null
        : null,

      defineValidClock: holiday.defineValidClock ?? ''
    };

    // RESET FORM WITH VALUES
    this.form.reset(patchData);

    // UPDATE FLAGS AFTER PATCH
    this.isSingleClockInStatus = !!holiday.isSingleClockIn;
    this.isMinimumWorkHoursStatus = !!holiday.isMinimumWorkHours;
    this.isBreakHoursStatus = !!holiday.isBreakHour;
    this.isSelfieStatus = !!holiday.isSelfie;
    this.isLossOfPayStatus = !!holiday.isLossOfPay;

    // DISABLE STATES
    this.isSingleClockInDisabled = this.isMinimumWorkHoursStatus;
    this.isMinimumWorkHoursDisabled = this.isSingleClockInStatus;

    // ✅ SET firstClockInTimeStatus AND isMarkedLateStatus based on saved value
    if (firstClockInMapped === FirstClockInAfterTime.CERTAINTIME) {
      this.firstClockInTimeStatus = true;
      this.isMarkedLateStatus = false;
      this.form.get('firstClockInTime')?.setValidators([Validators.required]);
    } else if (firstClockInMapped === FirstClockInAfterTime.MARKEDLATE) {
      this.isMarkedLateStatus = true;
      this.firstClockInTimeStatus = false;
      this.isLossOfPayStatus = !!holiday.isLossOfPay;
      this.form.get('firstClockInTime')?.clearValidators();
    } else {
      // DOSENOTMETTER
      this.firstClockInTimeStatus = false;
      this.isMarkedLateStatus = false;
      this.form.get('firstClockInTime')?.clearValidators();
    }

    this.form.get('firstClockInTime')?.updateValueAndValidity();

    // VALIDATORS for minimumWorkHours
    const minCtrl = this.form.get('minimumWorkHours');
    if (this.isMinimumWorkHoursStatus) {
      minCtrl?.setValidators([Validators.required]);
    } else {
      minCtrl?.clearValidators();
    }
    minCtrl?.updateValueAndValidity();

    // WEEKLY OFFS
    (holiday.weeklyOffs ?? []).forEach((dayLabel: string) => {
      const day = this.days.find(d => d.value === dayLabel);
      if (day) day.active = true;
    });


    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
    // OPEN MODAL
    this.modalService.open(content, {
      scrollable: false,
      centered: true,
      size: 'lg'
    });

    this.modalRef.result.then(
      () => {
        // closed normally
        this.modalRef = null;
      },
      () => {
        // backdrop click / ESC
        this.resetAttendancePolicyForm();

        // IMPORTANT
        // RESET STEP/PAGE
        this.currentStep = 1;

        this.modalRef = null;
      }
    );


  }


  isStepValid() {
    switch (this.currentStep) {
      case 1:
        return (
          this.form.get('businessId')?.valid &&
          this.form.get('shiftType')?.valid &&
          this.form.get('title')?.valid &&
          this.form.get('shiftStartTime')?.valid &&
          this.form.get('shiftEndTime')?.valid &&
          this.form.get('description')?.valid
        )
      case 2:
        return this.form.get('isBreakHour')?.valid
      case 3:
        return (
          this.form.get('isSingleClockIn')?.valid &&

          this.form.get('defineValidClock')?.valid &&
          this.form.get('isMinimumWorkHours')?.valid &&

          this.form.get('defineValidClock')?.valid &&
          this.form.get('workDayExtensionMinutes')?.valid &&
          this.form.get('firstClockInAfterTime')?.valid &&
          this.form.get('isSelfie')?.valid
        )
      default:
        return false
    }
  }



  // Function to go to the next step
  goToNextStep(): void {
    if (this.isStepValid()) {
      this.currentStep++
    } else {
      alert('Please complete the form before proceeding!')
    }
  }

  stepChange(newStep: number): void {
    if (this.isStepValid()) {
      this.currentStep = newStep
    }
  }

  // onSubmit() {

  //   // if (!this.isMinimumWorkHoursStatus && !this.isSingleClockInStatus) {
  //   //   this.toastr.error("Select Single ClockIn  OR Work Hour Calculation Method");
  //   //   return;
  //   // }
  //   const shiftType = this.form.value.shiftType;

  //   // if (
  //   //   (shiftType === this.shiftTypeEnum.SingleShift ||
  //   //     shiftType === this.shiftTypeEnum.FlexibleShift) &&
  //   //   this.shiftRecords.controls.length === 0 && !this.openEditPolicy
  //   // ) {
  //   //   this.toastr.error("You must add at least one shift for this policy");
  //   //   return;
  //   // }


  //   const isShiftType =
  //     shiftType === this.shiftTypeEnum.SingleShift ||
  //     shiftType === this.shiftTypeEnum.FlexibleShift;

  //   const hasValidShift = this.shiftRecords.controls.some(ctrl =>
  //     ctrl.value?.startTime && ctrl.value?.endTime
  //   );

  //   if (isShiftType && !hasValidShift) {
  //     this.toastr.error("You must add at least one shift for this policy");
  //     return;
  //   }
  //   if (this.form.valid) {
  //     if (!this.EditHoliday) {
  //       this.isLoading = true
  //       const selectedWeeklyOffs = this.days.filter(d => d.active).map(d => d.value)

  //       const variableWeeklyOffs = this.days
  //         .filter(d => d.active && d.weeks.length > 0)
  //         .map(d => ({ day: d.value, weeks: d.weeks }))

  //       const payload = {
  //         ...this.form.value,
  //         weeklyOffs: selectedWeeklyOffs,
  //         variableWeeklyOffs,

  //         // isSingleClockIn: this.isSingleClockInStatus,
  //         // isMinimumWorkHours: this.isMinimumWorkHoursStatus,
  //         isSelfie: this.isSelfieStatus,
  //         isBreakHour: this.isBreakHoursStatus,
  //         isLossOfPay: this.isLossOfPayStatus,
  //         isMarkedLate: this.isMarkedLateStatus,
  //       }
  //       // console.log("loss of pay ", this.isLossOfPayStatus);
  //       payload.isMidnightShift = payload.isMidnightShift ?? false;
  //       payload.isOvertimeEnabled = payload.isOvertimeEnabled ?? false;
  //       payload.isSingleClockIn = payload.isSingleClockIn ?? false;
  //       payload.isMinimumWorkHours = payload.isMinimumWorkHours ?? false;

  //       // (Optional but recommended)
  //       payload.lopCalculationPeriod = payload.lopCalculationPeriod ?? 'Monthly';

  //       this.attendancePolicyService.create(payload).subscribe({
  //         next: () => {
  //           // this.getAttendancePolicyList()
  //           this.resetAttendancePolicyForm()
  //           this.onClose()
  //           this.toastr.success('SUCCESS', 'Attendance Policy created successfully!')
  //           this.isLoading = false
  //           // console.log('modal closed');
  //         },
  //         error: (error: any) => {
  //           this.toastr.error('Error: ' + error.error.message)
  //           this.isLoading = false
  //         }
  //       })
  //     } else if (this.EditHoliday) {


  //       this.isLoading = true
  //       const selectedWeeklyOffs = this.days.filter(d => d.active).map(d => d.value)

  //       const variableWeeklyOffs = this.days
  //         .filter(d => d.active && d.weeks.length > 0)
  //         .map(d => ({ day: d.value, weeks: d.weeks }))



  //       const payload = {
  //         ...this.form.value,
  //         weeklyOffs: selectedWeeklyOffs,
  //         variableWeeklyOffs,


  //         isSingleClockIn: this.isSingleClockInStatus,
  //         isMinimumWorkHours: this.isMinimumWorkHoursStatus,
  //         isSelfie: this.isSelfieStatus,
  //         isBreakHour: this.isBreakHoursStatus,
  //         isLossOfPay: this.isLossOfPayStatus,
  //         isMarkedLate: this.isMarkedLateStatus,
  //       }

  //       // console.log('payload.isSingleClockIn AFTER BUILD:', payload.isSingleClockIn);
  //       // console.log('FULL PAYLOAD STRING:', JSON.stringify(payload));
  //       this.attendancePolicyService.update(this.EditHoliday.id, payload).subscribe({
  //         next: () => {
  //           this.toastr.success('SUCCESS', 'Attendance Policy updated successfully!')
  //           // this.getAttendancePolicyList()
  //           this.resetAttendancePolicyForm()
  //           this.onClose()
  //           this.isLoading = false
  //           this.EditHoliday = null
  //           // console.log('modal closed');
  //         },
  //         error: (error: { message: string }) => {
  //           this.isLoading = false
  //           this.toastr.error('Error: ' + error.message)
  //         }
  //       })
  //     }
  //   }

  //   // this code added by SHIVAM
  //   else if (this.assignAttendancePolicyform.valid) {
  //     const payload = {
  //       employeeIds: this.assignAttendancePolicyform.value.employeeIds,
  //       attendancePolicyId: this.assignAttendancePolicyform.value.attendancePolicyId,
  //       businessId: this.assignAttendancePolicyform.value.businessId,
  //       startDate: this.assignAttendancePolicyform.value.assignmentDate
  //     }

  //     // console.log(payload)

  //     this.attendancePolicyService.assignPolicy(payload).subscribe({
  //       next: () => {
  //         this.toastr.success('SUCCESS', 'Policy assigned successfully!')
  //         this.assignAttendancePolicyform.reset()
  //       },
  //       error: (error: any) => {
  //         this.toastr.error(error.message)
  //       }
  //     })
  //   }
  //   // here is the end of code added by SHIVAM
  //   else {
  //     // Mark all controls as touched to trigger validation error display
  //     this.form.markAllAsTouched()
  //   }
  // }


  // onSubmit() {
  //   const shiftType = this.form.value.shiftType;

  //   const isShiftType =
  //     shiftType === this.shiftTypeEnum.SingleShift ||
  //     shiftType === this.shiftTypeEnum.FlexibleShift;

  //   const hasValidShift = this.shiftRecords.controls.some(ctrl =>
  //     ctrl.value?.startTime && ctrl.value?.endTime
  //   );

  //   if (isShiftType && !hasValidShift && !this.isEditMode) {
  //     this.toastr.error("You must add at least one shift for this policy");
  //     return;
  //   }

  //   if (!this.isMinimumWorkHoursStatus && !this.isSingleClockInStatus) {
  //     this.toastr.error("Select Single ClockIn  OR Work Hour Calculation Method");
  //     return;
  //   }

  //   //     if (
  //   //   (shiftType === this.shiftTypeEnum.SingleShift ||
  //   //     shiftType === this.shiftTypeEnum.FlexibleShift) &&
  //   //   this.shiftRecords.controls.length === 0 && !this.openEditPolicy
  //   // ) {
  //   //   this.toastr.error("You must add at least one shift for this policy");
  //   //   return;
  //   // }

  //   if (!this.form.valid) {
  //     this.form.markAllAsTouched();
  //     return;
  //   }

  //   this.isLoading = true;

  //   const selectedWeeklyOffs = this.days
  //     .filter(d => d.active)
  //     .map(d => d.value);

  //   const variableWeeklyOffs = this.days
  //     .filter(d => d.active && d.weeks.length > 0)
  //     .map(d => ({ day: d.value, weeks: d.weeks }));

  //   const cleanedShiftRecords = (this.form.value.shiftRecords || [])
  //     .filter((sr: any) => sr.startTime && sr.endTime && sr.days?.length > 0)
  //     .map((sr: any) => ({
  //       startTime: sr.startTime,
  //       endTime: sr.endTime,
  //       days: sr.days,
  //       isBreakHour: sr.isBreakHour ?? false,
  //       breakHours: sr.breakHours ?? 0
  //     }));

  //   const finalShiftRecords =
  //     cleanedShiftRecords.length > 0 ? cleanedShiftRecords : undefined;

  //   const payload: any = {
  //     ...this.form.value,

  //     weeklyOffs: selectedWeeklyOffs,
  //     variableWeeklyOffs,
  //     shiftRecords: finalShiftRecords,

  //     isMidnightShift: this.form.value.isMidnightShift ?? false,
  //     isOvertimeEnabled: this.form.value.isOvertimeEnabled ?? false,
  //     isSingleClockIn: this.form.value.isSingleClockIn ?? false,
  //     isMinimumWorkHours: this.form.value.isMinimumWorkHours ?? false,

  //     isSelfie: this.isSelfieStatus ?? false,
  //     isBreakHour: this.isBreakHoursStatus ?? false,
  //     isLossOfPay: this.isLossOfPayStatus ?? false,
  //     isMarkedLate: this.isMarkedLateStatus ?? false,

  //     // ✅ FIX 1: 'Monthly' → 'MONTH' (must match LopCalculationPeriod enum)
  //     lopCalculationPeriod: this.form.value.lopCalculationPeriod || 'MONTH',

  //     shiftStartTime: this.form.value.shiftStartTime || null,
  //     shiftEndTime: this.form.value.shiftEndTime || null,
  //   };

  //   if (isShiftType) {
  //     payload.shiftStartTime = null;
  //     payload.shiftEndTime = null;
  //   }

  //   if (!payload.variableWeeklyOffs?.length) {
  //     delete payload.variableWeeklyOffs;
  //   }

  //   if (!payload.weeklyOffs?.length) {
  //     payload.weeklyOffs = [];
  //   }

  //   // ✅ FIX 2: remove firstClockInAfterTime long string — not a valid DB value
  //   if (
  //     payload.firstClockInAfterTime &&
  //     payload.firstClockInAfterTime.length > 10
  //   ) {
  //     payload.firstClockInAfterTime = null;
  //   }

  //   console.log("FINAL PAYLOAD:", payload);

  //   if (!this.EditHoliday) {
  //     this.attendancePolicyService.create(payload).subscribe({
  //       next: () => {
  //         this.toastr.success('SUCCESS', 'Attendance Policy created successfully!');
  //         this.isLoading = false;
  //         this.getAttendancePolicyList();
  //         this.onClose();
  //         this.form.reset();
  //         this.form.markAsPristine();
  //         this.form.markAsUntouched();
  //         this.shiftRecords.clear();

  //         this.days = this.days.map(d => ({ ...d, active: false, weeks: [] }));

  //         this.isSelfieStatus = false;
  //         this.isBreakHoursStatus = false;
  //         this.isLossOfPayStatus = false;
  //         this.isMarkedLateStatus = false;

  //         this.selectedBusiness = null;
  //         this.selectedBusinessId = null;
  //         this.EditHoliday = null;

  //         this.isLoading = false;
  //       },
  //       error: (error: any) => {
  //         console.error("CREATE ERROR:", error);
  //         this.toastr.error(error?.error?.message || 'Internal Server Error');
  //         this.isLoading = false;
  //       }
  //     });

  //   } else {
  //     this.attendancePolicyService.update(this.EditHoliday.id, payload).subscribe({
  //       next: () => {
  //         this.toastr.success('SUCCESS', 'Attendance Policy updated successfully!');
  //         this.getAttendancePolicyList();
  //         this.onClose();
  //         this.form.reset();
  //         this.form.markAsPristine();
  //         this.form.markAsUntouched();
  //         this.shiftRecords.clear();

  //         this.days = this.days.map(d => ({ ...d, active: false, weeks: [] }));

  //         this.isSelfieStatus = false;
  //         this.isBreakHoursStatus = false;
  //         this.isLossOfPayStatus = false;
  //         this.isMarkedLateStatus = false;

  //         this.selectedBusiness = null;
  //         this.selectedBusinessId = null;
  //         this.EditHoliday = null;

  //         this.isLoading = false;
  //       },
  //       error: (error: any) => {
  //         console.error("UPDATE ERROR:", error);
  //         this.toastr.error(error?.error?.message || 'Update failed');
  //         this.isLoading = false;
  //       }
  //     });
  //   }
  // }

  onSubmit() {
    const shiftType = this.form.value.shiftType;

    const isShiftType =
      shiftType === this.shiftTypeEnum.SingleShift ||
      shiftType === this.shiftTypeEnum.FlexibleShift;

    const hasValidShift = this.shiftRecords.controls.some(ctrl =>
      ctrl.value?.startTime && ctrl.value?.endTime
    );

    if (isShiftType && !hasValidShift && !this.isEditMode) {
      this.toastr.error("You must add at least one shift for this policy");
      return;
    }

    if (!this.isMinimumWorkHoursStatus && !this.isSingleClockInStatus) {
      this.toastr.error("Select Single ClockIn OR Work Hour Calculation Method");
      return;
    }

    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isLoading = true;

    // -----------------------------
    // WEEKLY OFFS
    // -----------------------------
    const selectedWeeklyOffs = this.days
      .filter(d => d.active)
      .map(d => d.value);

    const variableWeeklyOffs = this.days
      .filter(d => d.active && d.weeks.length > 0)
      .map(d => ({ day: d.value, weeks: d.weeks }));

    // -----------------------------
    // SHIFT RECORDS
    // -----------------------------
    const cleanedShiftRecords = (this.form.value.shiftRecords || [])
      .filter((sr: any) => sr.startTime && sr.endTime && sr.days?.length > 0)
      .map((sr: any) => ({
        startTime: sr.startTime,
        endTime: sr.endTime,
        days: sr.days,
        isBreakHour: sr.isBreakHour ?? false,
        breakHours: sr.breakHours ?? 0
      }));

    const finalShiftRecords =
      cleanedShiftRecords.length > 0 ? cleanedShiftRecords : undefined;

    // -----------------------------
    // FORM VALUE (SINGLE SOURCE OF TRUTH)
    // -----------------------------
    const formValue = this.form.getRawValue();

    // -----------------------------
    // PAYLOAD
    // -----------------------------
    const payload: any = {
      ...formValue,

      weeklyOffs: selectedWeeklyOffs,
      variableWeeklyOffs,
      shiftRecords: finalShiftRecords,

      // Direct from FORM (NO FLAGS)
      isMidnightShift: formValue.isMidnightShift,
      isOvertimeEnabled: formValue.isOvertimeEnabled,
      isSingleClockIn: formValue.isSingleClockIn,
      isMinimumWorkHours: formValue.isMinimumWorkHours,
      isSelfie: formValue.isSelfie,
      isBreakHour: formValue.isBreakHour,
      isLossOfPay: formValue.isLossOfPay,
      isMarkedLate: formValue.isMarkedLate,

      bufferZone: this.form.value.bufferZone ?? 0,
      PolicyEffectiveDate: this.form.value.PolicyEffectiveDate ?? '',
      lopCalculationPeriod: formValue.lopCalculationPeriod || 'MONTH',

      shiftStartTime: formValue.shiftStartTime || null,
      shiftEndTime: formValue.shiftEndTime || null,
    };

    // -----------------------------
    // SHIFT TYPE CLEANUP
    // -----------------------------
    if (isShiftType) {
      payload.shiftStartTime = null;
      payload.shiftEndTime = null;
    }

    // -----------------------------
    // CLEAN EMPTY VALUES
    // -----------------------------
    if (!payload.variableWeeklyOffs?.length) {
      delete payload.variableWeeklyOffs;
    }

    if (!payload.weeklyOffs?.length) {
      payload.weeklyOffs = [];
    }

    const booleanFields = [
      'isMidnightShift',
      'isOvertimeEnabled',
      'isSingleClockIn',
      'isMinimumWorkHours',
      'isSelfie',
      'isBreakHour',
      'isLossOfPay',
      'isMarkedLate',
      'disabled'
    ];

    booleanFields.forEach(field => {
      if (payload[field] === null || payload[field] === undefined) {
        payload[field] = false;
      }
    });

    // -----------------------------
    // CLEAN INVALID FIELD
    // -----------------------------
    // if (
    //   payload.firstClockInAfterTime &&
    //   payload.firstClockInAfterTime.length > 10
    // ) {
    //   payload.firstClockInAfterTime = null;
    // }

    // console.log("FINAL PAYLOAD:", payload);

    // -----------------------------
    // CREATE / UPDATE
    // -----------------------------

    console.log("yoyoyoyoy FINAL PAYLOAD:", JSON.stringify(payload, null, 2));
    const request$ = this.EditHoliday
      ? this.attendancePolicyService.update(this.EditHoliday.id, payload)
      : this.attendancePolicyService.create(payload);

    // request$.subscribe({
    //   next: () => {
    //     this.toastr.success(
    //       'SUCCESS',
    //       this.EditHoliday
    //         ? 'Attendance Policy updated successfully!'
    //         : 'Attendance Policy created successfully!'
    //     );

    //     this.isLoading = false;
    //     this.getAttendancePolicyList();
    //     this.onClose();

    //     // RESET ALL
    //     this.form.reset();
    //     this.form.markAsPristine();
    //     this.form.markAsUntouched();
    //     this.shiftRecords.clear();

    //     this.days = this.days.map(d => ({
    //       ...d,
    //       active: false,
    //       weeks: []
    //     }));

    //     this.isSelfieStatus = false;
    //     this.isBreakHoursStatus = false;
    //     this.isLossOfPayStatus = false;
    //     this.isMarkedLateStatus = false;

    //     this.selectedBusiness = null;
    //     this.selectedBusinessId = null;
    //     this.EditHoliday = null;

    //     this.isLoading = false;
    //   },
    //   error: (error: any) => {
    //     console.error("SAVE ERROR:", error);
    //     this.toastr.error(error?.error?.message || 'Operation failed');
    //     this.isLoading = false;
    //   }
    // });
    // request$.subscribe({
    //   next: (response: any) => {
    //     this.toastr.success(
    //       'SUCCESS',
    //       this.EditHoliday
    //         ? 'Attendance Policy updated successfully!'
    //         : 'Attendance Policy created successfully!'
    //     );

    //     this.isLoading = false;
    //     this.EditHoliday = null;

    //     // ✅ Close modal FIRST
    //     this.modalService.dismissAll();
    //     this.currentStep = 1;

    //     // ✅ Reset form completely with safe defaults
    //     this.form.reset({
    //       businessId: '',
    //       title: '',
    //       description: '',
    //       shiftType: '',
    //       shiftStartTime: '',
    //       shiftEndTime: '',
    //       isMidnightShift: false,
    //       isOvertimeEnabled: false,
    //       lopCalculationPeriod: 'MONTH',
    //       weeklyOffs: [],
    //       isBreakHour: false,
    //       breakHour: 0,
    //       defineValidClock: this.defineValidClockEnum.FIRSTCLOCKINLASTCLOCKOUT,
    //       isMinimumWorkHours: false,
    //       minimumWorkHours: 0,
    //       workDayExtensionMinutes: 0,
    //       isSelfie: false,
    //       firstClockInAfterTime: FirstClockInAfterTime.DOSENOTMETTER,
    //       isMarkedLate: false,
    //       firstClockInTime: null,
    //       isLossOfPay: false,
    //       lopDays: 0,
    //       isSingleClockIn: false,
    //       everyLateDays: 0,
    //       disabled: false,
    //     });

    //     // ✅ Reset FormArrays
    //     this.form.setControl('shiftRecords', this.fb.array([]));
    //     this.form.setControl('variableWeeklyOffs', this.fb.array([]));

    //     this.form.markAsPristine();
    //     this.form.markAsUntouched();

    //     // ✅ Reset all flags
    //     this.isSelfieStatus = false;
    //     this.isBreakHoursStatus = false;
    //     this.isLossOfPayStatus = false;
    //     this.isMarkedLateStatus = false;
    //     this.isSingleClockInStatus = false;
    //     this.isMinimumWorkHoursStatus = false;
    //     this.isSingleClockInDisabled = false;
    //     this.isMinimumWorkHoursDisabled = false;
    //     this.firstClockInTimeStatus = false;
    //     this.defineValidClockStatus = false;
    //     this.isEditMode = false;

    //     // ✅ Reset days
    //     this.days = this.days.map(d => ({
    //       ...d,
    //       active: false,
    //       weeks: []
    //     }));

    //     // ✅ Refresh list AFTER reset
    //     this.getAttendancePolicyList();
    //   },
    //   error: (error: any) => {
    //     console.error("SAVE ERROR:", error);
    //     this.toastr.error(error?.error?.message || 'Operation failed');
    //     this.isLoading = false;
    //   }
    // });

    request$.subscribe({
      next: (response: any) => {
        this.toastr.success(
          'SUCCESS',
          this.EditHoliday
            ? 'Attendance Policy updated successfully!'
            : 'Attendance Policy created successfully!'
        );

        this.isLoading = false;
        this.EditHoliday = null;
        this.isEditMode = false;

        // ✅ Close modal first
        this.modalService.dismissAll();
        this.currentStep = 1;

        // ✅ Reset form using SAME defaults as ngOnInit — nothing will be null
        this.form.reset({
          businessId: '',
          title: '',
          description: '',
          shiftType: '',
          shiftStartTime: '',
          shiftEndTime: '',
          isMidnightShift: false,          // ✅ matches ngOnInit default
          isOvertimeEnabled: false,        // ✅ matches ngOnInit default
          lopCalculationPeriod: 'MONTH',
          weeklyOffs: '',
          isBreakHour: false,
          breakHour: 0,
          defineValidClock: this.defineValidClockEnum.FIRSTCLOCKINLASTCLOCKOUT,
          isMinimumWorkHours: false,
          minimumWorkHours: 0,
          workDayExtensionMinutes: 0,
          isSelfie: false,
          firstClockInAfterTime: FirstClockInAfterTime.DOSENOTMETTER,
          firstClockInTime: null,
          isMarkedLate: false,
          isLossOfPay: false,
          lopDays: 0,
          isSingleClockIn: false,
          everyLateDays: 0,
          disabled: false,
        });

        // ✅ Reset FormArrays separately (reset() doesn't touch them)
        this.form.setControl('shiftRecords', this.fb.array([]));
        this.form.setControl('variableWeeklyOffs', this.fb.array([]));

        this.form.markAsPristine();
        this.form.markAsUntouched();

        // ✅ Reset all UI flags
        this.isSelfieStatus = false;
        this.isBreakHoursStatus = false;
        this.isLossOfPayStatus = false;
        this.isMarkedLateStatus = false;
        this.isSingleClockInStatus = false;
        this.isMinimumWorkHoursStatus = false;
        this.isSingleClockInDisabled = false;
        this.isMinimumWorkHoursDisabled = false;
        this.firstClockInTimeStatus = false;
        this.defineValidClockStatus = false;

        // ✅ Reset days
        this.days = this.days.map(d => ({
          ...d,
          active: false,
          weeks: []
        }));

        // ✅ Refresh list last
        this.getAttendancePolicyList();
      },
      error: (error: any) => {
        console.error("SAVE ERROR:", error);
        this.toastr.error(error?.error?.message || 'Operation failed');
        this.isLoading = false;
      }
    });
  }
  handleSortChange(event: Event): void {
    const target = event.target as HTMLSelectElement // Cast to HTMLSelectElement
    this.selectedBusiness = target.value // Access the value
    this.getAttendancePolicyList() // Call your function
  }

  toggleBreakhours(status: boolean) {
    // this.isBreakHoursStatus = !this.isBreakHoursStatus;
    // this.form.get('isBreakHours')?.setValue(this.isBreakHoursStatus ==  true ? '1' : '0');
    this.isBreakHoursStatus = status
    // this.form.get('isBreakHour')?.setValue(status)
  }

  // toggleisSingleClockIn() {
  //   this.isSingleClockInStatus = !this.isSingleClockInStatus
  //   this.form.get('isSingleClockIn')?.setValue(this.isSingleClockInStatus)

  //   //  shivam 22-04-2026
  //   // const value = this.form.get('isSingleClockIn')?.value;

  //   // if (value) {
  //   //   this.form.get('isMinimumWorkHours')?.setValue(false);
  //   //   this.form.get('isMinimumWorkHours')?.disable();
  //   // } else {
  //   //   this.form.get('isMinimumWorkHours')?.enable();
  //   // }

  // }

  // toggleisMinimumWorkHours() {
  //   this.isMinimumWorkHoursStatus = !this.isMinimumWorkHoursStatus
  //   this.form.get('isMinimumWorkHours')?.setValue(this.isMinimumWorkHoursStatus)
  //   const minimumWorkHoursControl = this.form.get('minimumWorkHours')

  //   // shivam 22-04-2026
  //   const value = this.form.get('isMinimumWorkHours')?.value;

  //   // if (value) {
  //   //   this.form.get('isSingleClockIn')?.setValue(false);
  //   //   this.form.get('isSingleClockIn')?.disable();
  //   // } else {
  //   //   this.form.get('isSingleClockIn')?.enable();
  //   // }

  //   // if (this.isMinimumWorkHoursStatus) {
  //   //   minimumWorkHoursControl?.setValidators([Validators.required])
  //   // } else {
  //   //   minimumWorkHoursControl?.clearValidators()
  //   // }

  //   minimumWorkHoursControl?.updateValueAndValidity()
  // }






  isSingleClockInDisabled = false;
  isMinimumWorkHoursDisabled = false;
  toggleisSingleClockIn() {
    if (this.isSingleClockInDisabled) return; // guard

    this.isSingleClockInStatus = !this.isSingleClockInStatus;
    this.form.get('isSingleClockIn')?.setValue(this.isSingleClockInStatus, { emitEvent: false });

    if (this.isSingleClockInStatus) {
      // disable minimum work hours
      this.isMinimumWorkHoursDisabled = true;
      this.isMinimumWorkHoursStatus = false;
      this.form.get('isMinimumWorkHours')?.setValue(false, { emitEvent: false });
      this.form.get('minimumWorkHours')?.clearValidators();
      this.form.get('minimumWorkHours')?.updateValueAndValidity();
    } else {
      this.isMinimumWorkHoursDisabled = false;
    }
  }

  toggleisMinimumWorkHours() {
    if (this.isMinimumWorkHoursDisabled) return; // guard


    this.isMinimumWorkHoursStatus = !this.isMinimumWorkHoursStatus;
    this.form.get('isMinimumWorkHours')?.setValue(this.isMinimumWorkHoursStatus, { emitEvent: false });

    const minimumWorkHoursControl = this.form.get('minimumWorkHours');

    if (this.isMinimumWorkHoursStatus) {
      // disable single clock in
      this.isSingleClockInDisabled = true;
      this.isSingleClockInStatus = false;
      this.form.get('isSingleClockIn')?.setValue(false, { emitEvent: false });
      minimumWorkHoursControl?.setValidators([Validators.required]);
    } else {
      this.isSingleClockInDisabled = false;
      minimumWorkHoursControl?.clearValidators();
    }

    minimumWorkHoursControl?.updateValueAndValidity();
  }


  toggleisSelfie() {
    this.isSelfieStatus = !this.isSelfieStatus
    this.form.get('isSelife')?.setValue(this.isSelfieStatus)
  }

  // toggleFirstclockin(status: string) {
  //   if (status === 'firstclockin') {
  //     this.firstClockInTimeStatus = false
  //     this.isMarkedLateStatus = false
  //     this.form.get('firstClockInTime')?.setValue(null)
  //     this.form.get('isMarkedLate')?.setValue(this.isMarkedLateStatus)
  //     this.form.get('firstClockInTime')?.clearValidators()
  //     this.form.get('firstClockInTime')?.updateValueAndValidity()
  //   } else if (status === 'everyvalidclockin') {
  //     this.firstClockInTimeStatus = true
  //     this.isMarkedLateStatus = false
  //     this.form.get('firstClockInTime')?.setValidators([Validators.required])
  //     // console.log(this.firstClockInTimeStatus)
  //     this.form.get('firstClockInTime')?.updateValueAndValidity()

  //     this.form.get('isMarkedLate')?.setValue(this.isMarkedLateStatus)

  //     // console.log(this.isMarkedLateStatus)
  //   } else if (status === 'markedlate') {
  //     this.firstClockInTimeStatus = false
  //     this.isMarkedLateStatus = true
  //     this.form.get('firstClockInTime')?.setValue(null)
  //     this.form.get('isMarkedLate')?.setValue(this.isMarkedLateStatus)
  //     this.form.get('firstClockInTime')?.clearValidators()
  //     this.form.get('firstClockInTime')?.updateValueAndValidity()
  //   }


  // }

  // toggleFirstclockin(status: string) {

  //   // RESET EVERYTHING FIRST
  //   this.firstClockInTimeStatus = false;
  //   this.isMarkedLateStatus = false;

  //   this.form.get('firstClockInTime')?.clearValidators();

  //   // -----------------------------
  //   // DOES NOT MATTER
  //   // -----------------------------
  //   if (status === 'firstclockin') {

  //     this.form.patchValue({
  //       isMarkedLate: false,
  //       firstClockInTime: null,
  //       lopDays: null,
  //       everyLateDays: null
  //     });

  //   }

  //   // -----------------------------
  //   // CERTAIN TIME
  //   // -----------------------------
  //   else if (status === 'everyvalidclockin') {

  //     this.firstClockInTimeStatus = true;

  //     this.form.patchValue({
  //       isMarkedLate: false
  //     });

  //     this.form.get('firstClockInTime')?.setValidators([
  //       Validators.required
  //     ]);
  //   }

  //   // -----------------------------
  //   // MARKED LATE
  //   // -----------------------------
  //   else if (status === 'markedlate') {

  //     this.isMarkedLateStatus = true;

  //     this.form.patchValue({
  //       isMarkedLate: true,
  //       firstClockInTime: null
  //     });
  //   }

  //   this.form.get('firstClockInTime')?.updateValueAndValidity();
  // }
  //  toggleFirstclockin(status: string) {
  //   // RESET ALL FIRST
  //   this.firstClockInTimeStatus = false;
  //   this.isMarkedLateStatus = false;
  //   this.form.get('firstClockInTime')?.clearValidators();

  //   if (status === 'firstclockin') {
  //     // Clear everything
  //     this.form.patchValue({
  //       isMarkedLate: false,
  //       firstClockInTime: null,
  //       lopDays: 0,
  //       everyLateDays: 0,
  //       isLossOfPay: false
  //     });
  //     this.isLossOfPayStatus = false;

  //   } else if (status === 'everyvalidclockin') {
  //     this.firstClockInTimeStatus = true;

  //     // Clear LOP fields from markedlate
  //     this.form.patchValue({
  //       isMarkedLate: false,
  //       lopDays: 0,
  //       everyLateDays: 0,
  //       isLossOfPay: false,
  //       firstClockInTime: null   // ✅ clear old value so user enters fresh
  //     });
  //     this.isLossOfPayStatus = false;

  //     this.form.get('firstClockInTime')?.setValidators([Validators.required]);

  //   } else if (status === 'markedlate') {
  //     this.isMarkedLateStatus = true;

  //     // Clear firstClockInTime from everyvalidclockin
  //     this.form.patchValue({
  //       isMarkedLate: true,
  //       firstClockInTime: null   // ✅ clear old value
  //     });
  //   }

  //   this.form.get('firstClockInTime')?.updateValueAndValidity();
  // }


  toggleFirstclockin(status: string) {
    // RESET FLAGS FIRST
    this.firstClockInTimeStatus = false;
    this.isMarkedLateStatus = false;
    this.form.get('firstClockInTime')?.clearValidators();

    if (status === 'firstclockin') {
      // DOES NOT MATTER — clear both other sections
      this.firstClockInTimeStatus = false;
      this.isMarkedLateStatus = false;

      this.form.patchValue({
        isMarkedLate: false,
        firstClockInTime: null,  // clear CERTAINTIME field
        lopDays: 0,              // clear MARKEDLATE fields
        everyLateDays: 0,
        isLossOfPay: false
      });
      this.isLossOfPayStatus = false;

    } else if (status === 'everyvalidclockin') {
      // CERTAIN TIME — clear MARKEDLATE fields, RESTORE firstClockInTime from EditHoliday
      this.firstClockInTimeStatus = true;
      this.isMarkedLateStatus = false;

      this.form.patchValue({
        isMarkedLate: false,
        lopDays: 0,
        everyLateDays: 0,
        isLossOfPay: false,
        // ✅ Restore saved value if coming back to this option
        firstClockInTime: this.EditHoliday?.firstClockInTime ?? null
      });
      this.isLossOfPayStatus = false;

      this.form.get('firstClockInTime')?.setValidators([Validators.required]);

    } else if (status === 'markedlate') {
      // MARKED LATE — clear CERTAINTIME field, RESTORE lop fields from EditHoliday
      this.isMarkedLateStatus = true;
      this.firstClockInTimeStatus = false;

      this.form.patchValue({
        isMarkedLate: true,
        firstClockInTime: null,  // clear CERTAINTIME field
        // ✅ Restore saved values if coming back to this option
        lopDays: this.EditHoliday?.lopDays ?? 0,
        everyLateDays: this.EditHoliday?.everyLateDays ?? 0,
        isLossOfPay: this.EditHoliday?.isLossOfPay ?? false,
        lopCalculationPeriod: this.EditHoliday?.lopCalculationPeriod ?? 'MONTH'
      });
      this.isLossOfPayStatus = this.EditHoliday?.isLossOfPay ?? false;
    }

    this.form.get('firstClockInTime')?.updateValueAndValidity();
  }
  // toggleDisabled(dayLabel: any) {
  //   dayLabel.disabled = !dayLabel.disabled
  //   dayLabel.active = !dayLabel.active // Toggle active state

  //   const day = this.days.find(d => d.label === dayLabel)
  //   if (day) {
  //     day.active = !day.active // Toggle the active state
  //     if (!day.active) {
  //       day.weeks = [] // reset if unselected
  //     }
  //   }
  //   this.updateWeeklyOffs()
  // }

  // toggleDisabled(day: any) {
  //   day.active = !day.active
  //   if (!day.active) {
  //     day.weeks = []
  //   }
  // }

  // this code is add by shivam 21-04-2026
  toggleDisabled(day: Day) {
    const updatedDays = this.days.map(d => {
      if (d.value === day.value) {
        return {
          ...d,
          active: !d.active,
          weeks: !d.active ? [] : d.weeks
        };
      }
      return d;
    });

    this.days = updatedDays;

    const selectedOffDays = updatedDays
      .filter(d => d.active)
      .map(d => d.value);

    this.form.patchValue({
      weeklyOffs: selectedOffDays
    });

    this.reorderDays()
  }

  toggleWeekSelection(day: any, weekValue: string) {
    const index = day.weeks.indexOf(weekValue)
    if (index > -1) {
      day.weeks.splice(index, 1)
    } else {
      day.weeks.push(weekValue)
    }
  }

  getSelectedWeeklyOffs() {
    return this.days
      .filter(day => day.active && day.weeks.length > 0)
      .map(day => ({
        day: day.value,
        weeks: day.weeks
      }))
  }

  // this code is added by shivam
  isWeeklyOff(day: string): boolean {
    return this.days
      .filter(d => d.active) // get weekly offs
      .map(d => d.value)
      .includes(day)
  }

  // updateWeeklyOffs() {
  //   const selectedDays = this.days.filter(day => !day.disabled).map(day => day.label);
  //   this.form.get('shiftInfoForm.weeklyOffs')?.setValue(selectedDays.join(', '));
  // }

  updateWeeklyOffs() {
    const selectedDays = this.days.filter(day => day.active).map(day => day.label)
    this.form.get('weeklyOffs')?.setValue(selectedDays.join(', '))
    // console.log('weekly offs', this.form.get('shiftInfoForm.weeklyOffs')?.getRawValue());
  }

  toggleDefineValidClock(status: boolean) {
    this.defineValidClockStatus = status
    if (status === true) {
      this.form.get('defineValidClock')?.setValue('First Clock In Last Clock Out')
    } else {
      this.form.get('defineValidClock')?.setValue('Every Valid Clock In and Clock Out Pair')
    }
  }

  //get employeeIds(): FormArray {
  //  return this.assignAttendancePolicyform.get('employeeIds') as FormArray
  //}

  // onEmployeeSelect(event: Event) {
  //   const selectedOptions = (event.target as HTMLSelectElement).selectedOptions
  //   const employeeIds: string[] = []

  //   // eslint-disable-next-line @typescript-eslint/prefer-for-of
  //   for (let i = 0; i < selectedOptions.length; i++) {
  //     const rawValue = selectedOptions[i].value
  //     const employeeId = rawValue.split(':')[1]?.trim().replace(/['"]/g, '')
  //     if (employeeId) employeeIds.push(employeeId)
  //   }

  //   this.assignAttendancePolicyform.get('employeeIds')?.setValue(employeeIds)
  // }

  // This code is Add By SHIVAM
  onEmployeeSelect(selectedItems: any[]) {
    const employeeIds = selectedItems.map((item: any) => item.id)
    this.assignAttendancePolicyform.get('employeeIds')?.setValue(employeeIds)
  }

  // code added By SHIVAM

  // onAssignmentDateChange(event: any) {
  //   const selectedDate = event.target.value
  //   console.log('Assignment Date:', selectedDate)

  //   this.assignAttendancePolicyform.patchValue({
  //     assignmentDate: selectedDate
  //   })
  // }

  // onAssignmentDateChange(event: any) {
  //   const selectedDate = event.target.value

  //   this.assignAttendancePolicyform.patchValue({
  //     startDate: selectedDate
  //   })
  // }

  // onAssignmentDateChange(event: any) {
  //   const selectedDate = event.target.value
  //   this.assignAttendancePolicyform.patchValue({
  //     assignmentDate: selectedDate   // <-- correct key
  //   })
  // }

  onAssignmentDateChange(event: any) {
    const selectedDate = new Date(event.target.value)

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const tomorrow = new Date(today)
    tomorrow.setDate(today.getDate() + 1)

    if (selectedDate < tomorrow) {
      alert('Please select a date from tomorrow onwards')

      // reset value
      this.assignAttendancePolicyform.patchValue({
        assignmentDate: null
      })

      return
    }

    // valid date
    this.assignAttendancePolicyform.patchValue({
      assignmentDate: event.target.value
    })
  }

  // --------------------Code Ended----------------

  // onChangePolicyList(target: EventTarget | null) {
  //   this.employeeList = []
  //   this.policyList = []
  //   if (target instanceof HTMLSelectElement) {
  //     if (target.value) {
  //       this.selectedBusiness = target.value
  //       //const selectedBusinessId = target.value
  //       this.isArchived = false
  //       //let skip = this.currentPage * this.pageLimit - this.pageLimit
  //       //const search = this.search
  //       //  ? { $or: { businessId: { $like: `%${selectedBusinessId}%` } } }
  //       //  : { businessId: { $like: `%${selectedBusinessId}%` } }

  //       this.attendancePolicyService
  //         .list(this.selectedBusiness!, this.search!, this.currentPage, this.pageLimit)
  //         .subscribe({
  //           next: response => {
  //             // console.log('business', response.rows )
  //             this.policyList = response.attendancePolicies
  //             this.policyList.forEach(policy => {
  //               policy.shiftStartTime = new Date(`1970-01-01T${policy.shiftStartTime}`)
  //               policy.shiftEndTime = new Date(`1970-01-01T${policy.shiftEndTime}`)
  //             })
  //             // this.totalCount = response.count;
  //           },
  //           error: (error: { message: string }) => {
  //             this.toastr.error('Error: ' + error.message)
  //           }
  //         })
  //     }
  //     // else if (this.Editdesignation) {

  //     //   const selectedBusinessId = this.Editdesignation.businessId;
  //     //   this.isArchived = false;
  //     //   let skip = (this.currentPage * this.pageLimit) - this.pageLimit;
  //     //   let search = (this.search) ? { $or: { department: { $like: `%${this.search}%` } } } : { businessId: { $like: `%${selectedBusinessId}%` } };

  //     //   this.departmentService.list({
  //     //     // skip: skip,
  //     //     // limit: this.pageLimit,
  //     //     filter: search,

  //     //     order: this.order,
  //     //   }).subscribe({
  //     //     next: response => {
  //     //       // console.log('business', response.rows )
  //     //       this.departmentList = response.rows;
  //     //       // this.totalCount = response.count;
  //     //     },
  //     //     error: err => {
  //     //       console.error(err);
  //     //       this._notifications.error("ERROR", err.error && err.error.message || err.message || "", {
  //     //         timeOut: 5000,
  //     //         showProgressBar: true,
  //     //       })
  //     //     }
  //     //   });
  //     // } else {
  //     //   this.departmentList = [];
  //     // }
  //   }
  //   // else if (this.Editdesignation) {

  //   //   const selectedBusinessId = this.Editdesignation.businessId;
  //   //   this.isArchived = false;
  //   //   let skip = (this.currentPage * this.pageLimit) - this.pageLimit;
  //   //   let search = (this.search) ? { $or: { department: { $like: `%${this.search}%` } } } : { businessId: { $like: `%${selectedBusinessId}%` } };

  //   //   this.departmentService.list({
  //   //     // skip: skip,
  //   //     // limit: this.pageLimit,
  //   //     filter: search,

  //   //     order: this.order,
  //   //   }).subscribe({
  //   //     next: response => {
  //   //       // console.log('business', response.rows )
  //   //       this.departmentList = response.rows;
  //   //       this.form.get('departmentId')?.setValue(this.Editdesignation.departmentId);
  //   //       // this.totalCount = response.count;
  //   //     },
  //   //     error: err => {
  //   //       console.error(err);
  //   //       this._notifications.error("ERROR", err.error && err.error.message || err.message || "", {
  //   //         timeOut: 5000,
  //   //         showProgressBar: true,
  //   //       })
  //   //     }
  //   //   });
  //   // }
  // }

  onChangePolicyList(businessId: string) {
    this.employeeList = []
    this.policyList = []
    this.assignAttendancePolicyform.get('employeeIds')?.setValue('')
    this.assignAttendancePolicyform.get('attendancePolicyId')?.setValue('')

    if (businessId) {
      this.selectedBusiness = this.selectedBusinessId
      //const selectedBusinessId = target.value
      this.isArchived = false
      //let skip = this.currentPage * this.pageLimit - this.pageLimit
      //const search = this.search
      //  ? { $or: { businessId: { $like: `%${selectedBusinessId}%` } } }
      //  : { businessId: { $like: `%${selectedBusinessId}%` } }

      this.attendancePolicyService
        .list(this.selectedBusiness!, this.search!, this.currentPage, this.pageLimit)
        .subscribe({
          next: response => {
            // console.log('business', response.rows )
            this.policyList = response.attendancePolicies
            this.policyList.forEach(policy => {
              policy.shiftStartTime = new Date(`1970-01-01T${policy.shiftStartTime}`)
              policy.shiftEndTime = new Date(`1970-01-01T${policy.shiftEndTime}`)
            })
            // this.totalCount = response.count;
          },
          error: (error: { message: string }) => {
            this.toastr.error('Error: ' + error.message)
          }
        })
    }
    // else if (this.Editdesignation) {

    //   const selectedBusinessId = this.Editdesignation.businessId;
    //   this.isArchived = false;
    //   let skip = (this.currentPage * this.pageLimit) - this.pageLimit;
    //   let search = (this.search) ? { $or: { department: { $like: `%${this.search}%` } } } : { businessId: { $like: `%${selectedBusinessId}%` } };

    //   this.departmentService.list({
    //     // skip: skip,
    //     // limit: this.pageLimit,
    //     filter: search,

    //     order: this.order,
    //   }).subscribe({
    //     next: response => {
    //       // console.log('business', response.rows )
    //       this.departmentList = response.rows;
    //       // this.totalCount = response.count;
    //     },
    //     error: err => {
    //       console.error(err);
    //       this._notifications.error("ERROR", err.error && err.error.message || err.message || "", {
    //         timeOut: 5000,
    //         showProgressBar: true,
    //       })
    //     }
    //   });
    // } else {
    //   this.departmentList = [];
    // }

    // else if (this.Editdesignation) {

    //   const selectedBusinessId = this.Editdesignation.businessId;
    //   this.isArchived = false;
    //   let skip = (this.currentPage * this.pageLimit) - this.pageLimit;
    //   let search = (this.search) ? { $or: { department: { $like: `%${this.search}%` } } } : { businessId: { $like: `%${selectedBusinessId}%` } };

    //   this.departmentService.list({
    //     // skip: skip,
    //     // limit: this.pageLimit,
    //     filter: search,

    //     order: this.order,
    //   }).subscribe({
    //     next: response => {
    //       // console.log('business', response.rows )
    //       this.departmentList = response.rows;
    //       this.form.get('departmentId')?.setValue(this.Editdesignation.departmentId);
    //       // this.totalCount = response.count;
    //     },
    //     error: err => {
    //       console.error(err);
    //       this._notifications.error("ERROR", err.error && err.error.message || err.message || "", {
    //         timeOut: 5000,
    //         showProgressBar: true,
    //       })
    //     }
    //   });
    // }
  }

  onChangeEmployeeList(target: EventTarget | null) {
    this.employeeList = []
    if (target instanceof HTMLSelectElement) {
      if (target.value) {
        // const selectedBusinessId = target.value;
        this.isArchived = false
        //let skip = this.currentPage * this.pageLimit - this.pageLimit
        //const search = this.search
        //  ? { $or: { businessId: { $like: `%${this.selectedBusiness}%` } } }
        //  : { businessId: { $like: `%${this.selectedBusiness}%` } }

        //const Policysearch = this.search
        //  ? { $or: { businessId: { $like: `%${this.selectedBusiness}%` } } }
        //  : {
        //      businessId: { $like: `%${this.selectedBusiness}%` },
        //      attendancePolicyId: { $like: `%${target.value}%` }
        //    }
        // this.assignLeavePolicyService.list({
        //   filter: search
        // }).subscribe({
        //   next: response =>{
        //     policyAssignedEmployees = response.rows
        //   }
        // })

        // this.employeeService.employeeApi.getEmployeeList({
        //   // skip: skip,
        //   // limit: this.pageLimit,
        //   filter: search,

        //   // order: this.order,
        // }).subscribe({
        //   next: response => {
        //     // console.log('business', response.rows )
        //     this.employeeList = response.rows;
        //     // this.totalCount = response.count;
        //   },
        //   error: err => {
        //     console.error(err);
        //     this._notifications.error("ERROR", err.error && err.error.message || err.message || "", {
        //       timeOut: 5000,
        //       showProgressBar: true,
        //     })
        //   }
        // });
        // let params: any = ''
        // if (this.selectedBusiness) {
        //   // params.businessId = this.selectedBusiness
        //   params = `businessId=${encodeURIComponent(this.selectedBusiness)}`
        // }

        // const query = new URLSearchParams(params).toString()
        // forkJoin({
        //   policyAssigned: this.attendancePolicyService.assignedPolicyList(
        //     this.selectedBusiness!,
        //     this.currentPage,
        //     this.pageLimit
        //   ),
        //   // employeeList: this.userService.getUsers()

        //   employeeList: this.userService.getEmployees(params)
        // }).subscribe({
        //   next: ({ policyAssigned, employeeList }) => {
        //     const policyAssignedEmployeeIds = new Set(
        //       policyAssigned.assignedAttendancePolicies.map((employee: { userId: string }) => {
        //         // console.log('Assigned Employee:', employee)
        //         return employee.userId
        //       })
        //     )
        //     // console.log('policyAssignedEmployeeIds', policyAssignedEmployeeIds)
        //     // console.log('employee list', this.employeeList)
        //     // Filter employees who are not in the assigned policies
        //     this.employeeList = employeeList.users.filter(
        //       (employee: { id: string }) => !policyAssignedEmployeeIds.has(employee.id)
        //     )

        //     // Optionally, update total count if needed
        //     // this.totalCount = this.employeeList.length;
        //   },
        //   error: error => {
        //     this.toastr.error('Error: ' + error.message)
        //   }
        // })

        const businessId = this.selectedBusiness ?? this.selectedBusinessId

        // Build HttpParams safely
        let params = new HttpParams()
        if (businessId) {
          params = params.set('businessId', businessId)
        }

        // Build query string if needed
        // const query = new URLSearchParams(params as any).toString() // 'as any' workaround for URLSearchParams
        const query = params.toString()

        // forkJoin with correct isolated state
        forkJoin({
          policyAssigned: businessId
            ? this.attendancePolicyService.assignedPolicyList(
              businessId,
              this.currentPage,
              this.pageLimit
            )
            : this.attendancePolicyService.assignedPolicyList(
              undefined as any,
              this.currentPage,
              this.pageLimit
            ), // OR adjust method signature
          employeeList: this.userService.getEmployees(query)
        }).subscribe({
          next: ({ policyAssigned, employeeList }) => {
            const assignedEmployeeIds = new Set(
              policyAssigned.assignedAttendancePolicies.map(
                (employee: { userId: string }) => employee.userId
              )
            )

            // Filter employees who are not in the assigned policies
            this.employeeList = employeeList.users.filter(
              (employee: { id: string }) => !assignedEmployeeIds.has(employee.id)
            )
          },
          error: error => {
            this.toastr.error('Error: ' + error.message)
          }
        })
      }
    }
  }

  onAssign() {
    if (this.assignAttendancePolicyform.valid) {
      // Handle form submission
      // console.log(this.form.value);
      const { employeeIds, attendancePolicyId, assignmentDate } =
        this.assignAttendancePolicyform.value
      const formData = { employeeIds, attendancePolicyId, startDate: assignmentDate }
      if (!this.EditHoliday) {
        this.attendancePolicyService.assignPolicy(formData).subscribe({
          next: () => {
            this.toastr.success('SUCCESS', 'Attendance Policy assigned successfully!')
            // this.getAttendancePolicyList()
            this.resetAttendancePolicyForm()
            this.onClose()
            // console.log('modal closed');
          },
          error: (error: { message: string }) => {
            this.toastr.error('Error: ' + error.message)
          }
        })
      } else if (this.EditHoliday) {
        //this.assignAttendancePolicyService.update(this.EditHoliday.id, formData)
        this.attendancePolicyService.assignPolicy(formData).subscribe({
          next: () => {
            this.toastr.success('SUCCESS', 'Attendance Policy updated successfully!')
            // this.getAttendancePolicyList()
            this.resetAttendancePolicyForm()
            this.onClose()
            this.EditHoliday = null
            // console.log('modal closed');
          },
          error: (error: { message: string }) => {
            this.toastr.error('Error: ' + error.message)
          }
        })
      }
    } else {
      // Mark all controls as touched to trigger validation error display
      this.form.markAllAsTouched()
    }
  }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    this.getAttendancePolicyList() // Load employees with new page limit
  }

  private updatePageLastRecord() {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  // loadEmployees() {
  //   const params: any = {}
  //   if (this.businessIdss?.length) {
  //     params.businessIds = this.businessIdss.join(',')
  //   }
  //   // console.log('business ids', this.businessIdss)
  //   // if (this.search) {
  //   //   params.firstName = this.search
  //   // }

  //   // if (this.businessId) {
  //   //   params.businessId = this.businessId
  //   // }

  //   this.store.dispatch(
  //     loadEmployees({
  //       params: new URLSearchParams(params).toString()
  //     })
  //   )
  // }
  loadEmployees(): Observable<{ users: User[] }> {
    const params: any = {}
    // if (this.businessIdss?.length) {
    //   params.businessIds = this.businessIdss.join(',')
    // }
    if (this.selectedBusiness) {
      params.businessId = this.selectedBusiness
    }

    const query = new URLSearchParams(params).toString()
    this.store.dispatch(loadEmployees({ params: query }))

    // Wait for data from the store
    return this.store.select(selectAllUsers).pipe(
      filter(users => !!users), // only emit when users is available
      take(1), // complete after first emit
      tap(users => console.log('Loaded Users:', users)), // log users here
      map(users => ({ users })) // match the expected shape in forkJoin
    )
  }

  onBusinessChange(businessId: string) {
    if (businessId) {
      const control = this.form.get('businessId')
      control?.setValue(businessId)
      control?.markAsDirty()
      control?.markAsTouched()
      control?.updateValueAndValidity()

      this.selectedBusinessId = businessId
      // Call a method to fetch data based on the selected owner
      const params = `businessId=${encodeURIComponent(businessId)}`

      // this.store.dispatch(loadDepartments({ params })) // Dispatch action with filter
    } else {
      const params = ''
      // this.store.dispatch(loadDepartments({ params })) // Dispatch action with filter
      // Handle the case where no owner is selected
      // console.log('No business selected')
    }
  }

  loadAllBusinesses() {
    const params: any = {}
    if (this.businessIdss?.length) {
      params.businessIds = this.businessIdss.join(',')
    }
    params.disabled = false
    this.store.dispatch(
      loadBusinesses({
        params: new URLSearchParams(params).toString()
      })
    )
  }

  getDashboardRoute(): string {
    // return this.user?.role.name === 'Admin' ? eps.dashboardPath : eps.employeeDashboardPath
    return this.utilService.getDashboardRoute()
  }

  customSearchFn = (term: string, item: any) => {
    const fullName = item && item.businessName ? item.businessName.toLowerCase() : ''
    return fullName.includes(term ? term.toLowerCase() : '')
  }

  customSearchFnEmployee = (term: string, item: any) => {
    const fullName = `${item.firstName} ${item.lastName}`.toLowerCase()
    return fullName.includes(term ? term.toLowerCase() : '')
  }

  setAsDefault(policy: any) {
    this.attendancePolicyService.setDefaultPolicy(policy.id).subscribe({
      next: res => {
        this.toastr.success(res.message) // ✅ Show backend-provided success message
        this.getAttendancePolicyList()
        this.resetAttendancePolicyForm()
      },
      error: err => {
        console.error('Failed to set default policy', err)
        this.toastr.error(err?.error?.message || 'Something went wrong while updating the policy.')
      }
    })
  }

  // openAddShift() {
  //   this.tempShiftForm.reset({
  //     isBreakHour: false,
  //     breakHours: 0,
  //     isFullDay: true,
  //     hasMinHours: false,
  //     minimumHours: 0
  //   })
  //   this.selectedDays = []
  //   this.showShiftForm = true
  // }

  // submitShift() {
  //   if (this.tempShiftForm.invalid) return

  //   this.shiftRecords.push(this.fb.group(this.tempShiftForm.value))
  //   this.showShiftForm = false
  // }



  openAddShift() {


    const weeklyOffs = this.form.get('weeklyOffs')?.value || [];

    // console.log('WeeklyOffs RAW:', weeklyOffs);

    // Normalize weekly offs to string array
    const offDays = weeklyOffs.map((d: any) =>
      typeof d === 'string' ? d : d.day
    );

    // console.log('OffDays:', offDays);
    // console.log('All Days:', this.days);

    // Filter days
    this.availableDays = this.days.filter(day =>
      !offDays.includes(day.value)
    );

    // console.log('AvailableDays:', this.availableDays);t
    this.tempShiftForm.reset({
      isBreakHour: false,
      breakHours: 0,
      isFullDay: true,
      hasMinHours: false,
      minimumHours: 0
    })

    this.selectedDays = [] // still used
    this.showShiftForm = true
    this.cdr.detectChanges()
  }


  openEditShift(shift: any) {

    // 1. Get weekly offs
    const weeklyOffs = this.form.get('weeklyOffs')?.value || [];

    const offDays = weeklyOffs.map((d: any) =>
      typeof d === 'string' ? d : d.day
    );

    // 2. Filter available days
    this.availableDays = this.days.filter(day =>
      !offDays.includes(day.value)
    );

    // 3. 👉 Fill form with existing shift data
    this.tempShiftForm.patchValue({
      shiftStartTime: shift.shiftStartTime,
      shiftEndTime: shift.shiftEndTime,
      isBreakHour: shift.isBreakHour,
      breakHours: shift.breakHours,
      isFullDay: shift.isFullDay,
      hasMinHours: shift.hasMinHours,
      minimumHours: shift.minimumHours
    });

    // 4. 👉 VERY IMPORTANT (this is what you want)
    this.selectedDays = shift.days;

    // 5. Show form
    this.showShiftForm = true;
  }

  get shiftRecords(): FormArray {
    return this.form.get('shiftRecords') as FormArray
  }

  addShift(): void {
    this.shiftRecords.push(
      this.fb.group({
        days: this.fb.control([]), // must be an array
        startTime: ['', Validators.required],
        endTime: ['', Validators.required]
      })
    )
  }

  // this code is added by shivam
  //   transformShifts() {
  //   const finalShifts: any[] = [];

  //   this.shiftRecords.forEach((shift:any) => {
  //     shift.days.forEach((day: string) => {
  //       const existing = finalShifts.filter(s => s.dayOfWeek === day);

  //       finalShifts.push({
  //         dayOfWeek: day.toUpperCase(),
  //         startTime: shift.startTime,
  //         endTime: shift.endTime,
  //         shiftOrder: existing.length + 1,
  //         isOvernight: shift.endTime < shift.startTime
  //       });
  //     });
  //   });

  //   return finalShifts;
  // }

  // this code is add by shivam
  //   addShift() {
  //   const formValue = this.tempShiftForm.value;

  //   this.selectedDays.forEach((day: Day) => {
  //     const existing = this.shifts.filter(s => s.dayOfWeek === day);

  //     this.shifts.push({
  //       dayOfWeek: day,
  //       startTime: formValue.startTime,
  //       endTime: formValue.endTime,
  //       shiftOrder: existing.length + 1,
  //       isOvernight: formValue.endTime < formValue.startTime
  //     });
  //   });
  // }
  removeShift(index: number): void {
    this.shiftRecords.removeAt(index)
  }

  toggleDay(day: Day): void {
    const index = this.selectedDays.indexOf(day)

    if (index === -1) {
      this.selectedDays.push(day)
    } else {
      this.selectedDays.splice(index, 1)
    }



  }

  submitShift() {
    // if (this.tempShiftForm.invalid || this.selectedDays.length === 0) return

    // const shiftValue = {
    //   ...this.tempShiftForm.value,
    //   days: this.selectedDays
    // }

    // this.shiftRecords.push(this.fb.group(shiftValue))
    // this.showShiftForm = false

    if (this.tempShiftForm.invalid) return

    if (this.selectedDays.length === 0) {
      this.toastr.error("Please select at least one day for shift");
      return;
    }

    const formValue = this.tempShiftForm.value


    // Add selectedDays to the form value
    formValue.days = this.selectedDays.map(day => day.value)


    // this code is add by shivam 21-04-2026
    const start = formValue.startTime;
    const end = formValue.endTime;

    let crossesMidnight = false;

    if (start && end) {
      const [startH, startM] = start.split(':').map(Number);
      const [endH, endM] = end.split(':').map(Number);

      const startMinutes = startH * 60 + startM;
      const endMinutes = endH * 60 + endM;

      crossesMidnight = endMinutes < startMinutes;
    }


    const selectedDayValues = this.selectedDays.map(day => day.value);



    // Get all already assigned days from existing shifts
    const existingDays = this.shiftRecords.controls
      .flatMap(ctrl => ctrl.value.days || []);

    // Check for duplicates
    const duplicateDay = selectedDayValues.find(day => existingDays.includes(day));

    if (duplicateDay) {
      this.toastr.error(`Shift already assigned for ${duplicateDay}`);
      return;
    }
    // Push to the shiftRecords form array
    // this.shiftRecords.push(this.fb.group(formValue))
    this.shiftRecords.push(
      this.fb.group({
        startTime: [formValue.startTime],
        endTime: [formValue.endTime],
        days: [formValue.days],
        isBreakHour: [formValue.isBreakHour],
        breakHours: [formValue.breakHours],

        isFullDay: [formValue.isFullDay],
        hasMinHours: [formValue.hasMinHours],
        minimumHours: [formValue.minimumHours],

        // this tooo add by shivam
        crossesMidnight: [crossesMidnight],


      })
    )

    // Clear form and selected days
    this.tempShiftForm.reset()
    this.selectedDays = []
    this.showShiftForm = false

    this.closeOffcanvas()
    this.closeAllOffcanvas()
  }

  isArray(value: any): boolean {
    return Array.isArray(value)
  }

  closeOffcanvas() {
    if (this.offcanvasRef) {
      this.offcanvasRef.close()
      this.offcanvasService.dismiss()
    }
  }

  closeAllOffcanvas() {
    const openedOffcanvasElements = document.querySelectorAll('.offcanvas.show')
    openedOffcanvasElements.forEach((element: Element) => {
      const offcanvasInstance = bootstrap.Offcanvas.getInstance(element)
      if (offcanvasInstance) {
        offcanvasInstance.hide()
        // offcanvasInstance.close()
      }
    })
  }

  updateShiftTimeValidators(shiftType: string): void {
    const startControl = this.form.get('shiftStartTime')
    const endControl = this.form.get('shiftEndTime')

    if (
      shiftType === this.shiftTypeEnum.SingleShift ||
      shiftType === this.shiftTypeEnum.FlexibleShift
    ) {
      startControl?.clearValidators()
      endControl?.clearValidators()
      startControl?.setValue(null)
      endControl?.setValue(null)
    } else {
      startControl?.setValidators([Validators.required])
      endControl?.setValidators([Validators.required])
    }

    startControl?.updateValueAndValidity()
    endControl?.updateValueAndValidity()
  }

  isValidDate(date: any): boolean {
    return date && !isNaN(new Date(date).getTime())
  }

  get isAdmin(): boolean {
    return this.user?.userRoles?.some((ur: any) => ur.role?.name === 'Admin') ?? false
  }

  // private resetAttendancePolicyForm(): void {

  //   // Reset reactive forms
  //   // this.form.reset({
  //   //   businessId: this.selectedBusinessId ?? '',
  //   //   isBreakHour: false,
  //   //   breakHour: 0,
  //   //   isSingleClockIn: false,
  //   //   defineValidClock: this.defineValidClockEnum.EVERYVALIDCLOCKIN,
  //   //   isMinimumWorkHours: false,
  //   //   minimumWorkHours: 8,
  //   //   workDayExtensionMinutes: 0,
  //   //   isSelfie: false,
  //   //   firstClockInAfterTime: FirstClockInAfterTime.DOSENOTMETTER,
  //   //   isMarkedLate: false,
  //   //   isLossOfPay: false,
  //   //   lopDays: 0,
  //   //   everyLateDays: 0,
  //   //   disabled: false
  //   // })

  //   this.form.reset({
  //     businessId: '',
  //     isBreakHour: false,
  //     breakHour: 0,
  //     isSingleClockIn: false,
  //     defineValidClock: this.defineValidClockEnum.EVERYVALIDCLOCKIN,
  //     isMinimumWorkHours: false,
  //     minimumWorkHours: 8,
  //     workDayExtensionMinutes: 0,
  //     isSelfie: false,
  //     firstClockInAfterTime: FirstClockInAfterTime.DOSENOTMETTER,
  //     isMarkedLate: false,
  //     isLossOfPay: false,
  //     lopDays: 0,
  //     everyLateDays: 0,
  //     disabled: false
  //   });
  //   // Clear FormArrays
  //   // this.form.setControl('variableWeeklyOffs', this.fb.array([]))
  //   // this.form.setControl('shiftRecords', this.fb.array([]))

  //   // (this.form.get('variableWeeklyOffs') as FormArray).clear();
  //   // (this.form.get('shiftRecords') as FormArray).clear();
  //   this.form.setControl('shiftRecords', this.fb.array([]));
  //   this.form.setControl('variableWeeklyOffs', this.fb.array([]));
  //   // Reset assign form
  //   this.assignAttendancePolicyform.reset()


  //   this.selectedBusiness = null;
  //   this.selectedBusinessId = null;

  //   // Reset UI state
  //   this.currentStep = 1
  //   this.isLoading = false
  //   this.EditHoliday = null

  //   this.isBreakHoursStatus = false
  //   this.isSingleClockInStatus = false
  //   this.isMinimumWorkHoursStatus = false
  //   this.isSelfieStatus = false
  //   this.firstClockInTimeStatus = false
  //   this.isLossOfPayStatus = false
  //   this.isMarkedLateStatus = false
  //   this.defineValidClockStatus = false

  //   // Reset weekly off days
  //   this.days.forEach(day => {
  //     day.active = false
  //     day.weeks = []
  //   })
  //   // this.form.get('isMinimumWorkHours')?.setValue(false)
  //   // Reset temp shift form
  //   // this.tempShiftForm.reset({
  //   //   isBreakHour: false,
  //   //   breakHours: 0,
  //   //   isFullDay: true,
  //   //   hasMinHours: false,
  //   //   minimumHours: 0
  //   // })

  //   this.tempShiftForm.reset();
  //   this.tempShiftForm.markAsPristine();
  //   this.tempShiftForm.markAsUntouched();

  //   // Close modals/offcanvas
  //   this.modalService.dismissAll()
  //   this.closeAllOffcanvas()
  //   this.cdr.detectChanges() // force UI update
  // }

  // ✅ resetAttendancePolicyForm — remove the dismissAll line
  private resetAttendancePolicyForm(): void {
    this.form.reset({
      businessId: '',
      isBreakHour: false,
      breakHour: 0,
      isSingleClockIn: false,
      defineValidClock: this.defineValidClockEnum.EVERYVALIDCLOCKIN,
      isMinimumWorkHours: false,
      minimumWorkHours: 8,
      workDayExtensionMinutes: 0,
      isSelfie: false,
      firstClockInAfterTime: FirstClockInAfterTime.DOSENOTMETTER,
      isMarkedLate: false,
      isLossOfPay: false,
      lopDays: 0,
      everyLateDays: 0,
      disabled: false
    });

    this.form.setControl('shiftRecords', this.fb.array([]));
    this.form.setControl('variableWeeklyOffs', this.fb.array([]));

    this.assignAttendancePolicyform.reset();

    this.selectedBusiness = null;
    this.selectedBusinessId = null;

    this.currentStep = 1;
    this.isLoading = false;
    this.EditHoliday = null;

    this.isBreakHoursStatus = false;
    this.isSingleClockInStatus = false;
    this.isMinimumWorkHoursStatus = false;
    this.isSelfieStatus = false;
    this.firstClockInTimeStatus = false;
    this.isLossOfPayStatus = false;
    this.isMarkedLateStatus = false;
    this.defineValidClockStatus = false;

    this.days.forEach(day => {
      day.active = false;
      day.weeks = [];
    });

    this.tempShiftForm.reset();
    this.tempShiftForm.markAsPristine();
    this.tempShiftForm.markAsUntouched();

    // ❌ REMOVE THIS LINE — it was causing the double-close conflict
    // this.modalService.dismissAll()

    this.closeAllOffcanvas();
    this.cdr.detectChanges();
  }


  onChangeBusinessPolicyList() {
    this.attendancePolicyService.list(this.selectedBusinessId ?? '').subscribe(res => {
      this.modalPolicyList = res.attendancePolicies
    })
  }
}






// currently working in this code 
// private resetAttendancePolicyForm(): void {
//   this.form.reset({
//     businessId: this.selectedBusinessId ?? '',
//     isBreakHour: false,
//     breakHour: 0,
//     isSingleClockIn: false,
//     defineValidClock: this.defineValidClockEnum.EVERYVALIDCLOCKIN,
//     isMinimumWorkHours: false,
//     minimumWorkHours: 8,
//     workDayExtensionMinutes: 0,
//     isSelfie: false,
//     firstClockInAfterTime: FirstClockInAfterTime.DOSENOTMETTER,
//     isMarkedLate: false,
//     isLossOfPay: false,
//     lopDays: 0,
//     everyLateDays: 0,
//     disabled: false
//   })

//   this.form.setControl('variableWeeklyOffs', this.fb.array([]))
//   this.form.setControl('shiftRecords', this.fb.array([]))

//   this.assignAttendancePolicyform.reset()

//   this.currentStep = 1
//   this.isLoading = false
//   this.EditHoliday = null

//   this.isBreakHoursStatus = false
//   this.isSingleClockInStatus = false
//   this.isMinimumWorkHoursStatus = false
//   this.isSelfieStatus = false
//   this.firstClockInTimeStatus = false
//   this.isLossOfPayStatus = false
//   this.isMarkedLateStatus = false
//   this.defineValidClockStatus = false

//   this.days.forEach(day => {
//     day.active = false
//     day.weeks = []
//   })

//   this.tempShiftForm.reset({
//     isBreakHour: false,
//     breakHours: 0,
//     isFullDay: true,
//     hasMinHours: false,
//     minimumHours: 0
//   })

//   // ❌ REMOVE THESE
//   // this.modalService.dismissAll()
//   // this.closeAllOffcanvas()
//   // this.cdr.detectChanges()
// }
